import React, { useState, useRef, useEffect } from "react";

// ─────────────────────────────────────────────────────────────────────────────
// GCC.ai  v9  —  Greenleaf Clinical Resource
// • Hamburger trigger → left slide-over drawer (light palette, no emojis)
// • Smooth cubic-bezier slide transition with will-change
// • Drawer: Chat | ICD-10 | Reference (Local / Cloud only) | Settings (footer)
// • Clinical Brain always active · localStorage history · Retina-ready
// ─────────────────────────────────────────────────────────────────────────────

const ICON = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAIAAAB7GkOtAAAABmJLR0QA/wD/AP+gvaeTAAAgAElEQVR4nO3dZ3QV54Hw8blFuldX7aoXhCRUEQhEM9j0ZsA0g7HBNbHjFDtxNnFO3pRtSXbPnt1k391NdpM4e9aJ427jgulIgBBdVNGEJJBQAwHqvVzd8n4Qr8OiGSGkW+f5/z6FGenOwwnWXzPzzDOapDWzJQCAeLSeHgAAwDMIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigBARMGmQKO/v6dHAXiY3tMDANxHo9FsWrL8W2s3xEZE2uz2wssX//mdNytuXPf0uADP0CStme3pMQBu8p0nnn5tw6a7t7R1dm76+x9V377pqSEBHsQlIIgiNiLylXUb7tkYGhT0vY3PeWQ8gMcRAIhiwdTpep3MNc95OVPcPxjAGxAAiGJaRpbsdj8dd4MhKAIAUUxNHy+7vfxGjZtHAngJAgAhRJrDxkbHyO46c6XEzYMBvAQBgBCmZ8pf/5Ek6dyVUneOBPAeBABCyEnLUNpVdLXMnSMBvAcBgBCyklJkt9c1NtxqanTzYAAvQQAghPFJybLbL1Zcde9AAC9CAKB+sRER5qBg2V0l1dfcPBjAexAAqF9W0jilXaXV1e4cCeBVCADUT+kGgCRJpTWV7hwJ4FUIANQvbUyi7PaW9vbbzU1uHgzgPQgA1C85Lk52e1kt138gNAIAldNoNIlx8bK7Kut4EwCERgCgcjHh4YEGo+yuypt1bh4M4FUIAFQuJS5Bade1mzfcORLA2xAAqFxy/BilXdUEAGIjAFC5sVHyi4D2WfpvsggExEYAoHLxkVGy26833LbZ7W4eDOBVCABULj5KPgA3m+rdPBLA2xAAqNyYiGjZ7XUNDW4eCeBtCADUzOjvbw6WXwaurokAQHQEAGoWHxmt0Whkd9U1EgCIjgBAzWLCw5V2MQUIIABQs6jQMKVdvAgMIABQs0izYgCa2trcORLACxEAqFlEaKjs9s6erh5Ln5sHA3gbAgA1UzoDaGhtdfNIAC9EAKBmSvcAGloIAEAAoGoRISGy25vaCABAAKBqoUHyT4E1d3IHGCAAULWQoCDZ7W2dnW4eCeCFCABUy0+vD/A3yO5q7yIAAAGAeild/5Ekqb2ry50jAbwTAYBqhQYGKu1q6+xw50gA70QAoFrBJsUAtHd3u3MkgHciAFCtQINRaVdHD5eAAAIA9TL4+yvt6u2zuHMkgHciAFAtg0ExAH39BAAgAFAvo5/8HFBJknr7WAkOIABQryEuAfVZOAMACADUyzhEAPr73TkSwDsRAKiWUgAs/Va7w+7mwQBeiABAtfz18gHo6+cGACBJBAAqZlSYBdTLDQBAkiQCABUz+hEAYCgEAKqlNAuIKUDAAAIA1TIqrAXdyz0AQJIkAgAVU5oFxDoQwAACANXy99PLbu+z8hAAIEkEAACERQCgWg6Hp0cAeDcCANVyKBRA4+ZxAN6KAEA4GhIASJJEAKBiDknhDEBDAABJIgBQMaV7AAQAGEAAoFrcBAaGRgAgHO4BAAMIAFRL+R4ApwaAJEmS/KOSgBooTQMV8h5AUECgVqsJMZk0Gk1nT7fN7ui19Fr6rZ4eFzyJAEC1lJ4DUPGTALERESlxCcnxY5Jj4+LCI8NDQyPNYVHmsACFdfGsNltze1tLe3tDW3NjW1vVzRtVt25W1t2ounWDNoiAAAA+LNIcNjk1PSctIyctc+K4lKAA0wN9u16niw4Ljw4Lz5SS795utdkqrteeLy87X3H1QnlZ+Y3rzhw0vAYBgGopPgns45eA9DpdTlrGgqkzZmfnTEhOccVfR6/TZSYlZyYlb1yyXJKk5va2kyWXDhadOVB0qq2z0+mHg6cQAKiWXSEAOq1Pzn0w+vsvmDpj5cNz502ZpnRJx0XCQ0JXzJqzYtYcq81WWHx+57Ej+06f6OzpducY4AoEAKrV1y+/7LPBz8/NIxkNjUbz8MRJj89btHTGrEBjgGcHo9fp5k6eNnfytJ9b+guKTm3OzztefEH5Xgu8HQGAavX2yb/5y2hw66/PIxYUYFr5yNznl61KH5vo6bHcy+Dvt3zW7OWzZlfdqvu8YP/H+XntXVwa8j0EAKql9OpHpVdFeo/4yKiXV61bt2CxyWD09FjuIzk2/gdPv/DNxze8u2fnO3u2t3Z2eHpEeAAEAKqleAbgxQFIjov/xpon1s5doNf50n+bQQGmV9c/9ZXHVr+ft+vPu7a2dJAB3+BL/8iAB9LXL//uX4O/N94DiI2I+P7G51fPnu+j96glSQo0Bnxz7YZnlq74/ZbN7+ft6rfyJIG3IwBQrV6LfACM/v4ajcZ7bl2aDIbnlq361vqnAr3+gs9wBJsCf/zcS5uWLP/N5g/2nDjq6eFgKAQAqtWjEACtRuvvp++zeP7V8BqNZv38xT/Y9HxEqNnTY3Gy5Nj4nzz/0t5Tx212u6fHAkUEAKrV1ycfAEmSjP4GjwcgMTr2Zy+/Mjs7x7PDcJ1tRw/y09/LEQCoVo+lV2mX0d/QJnls2qJep//6mnWvPL7RO+9GOMu2wwc8PQTcBwGAaindA5A8OhFoTGT0/33tB1PSMz01APe4eK2cFYS8HwGAavUpTAOVJMlo8HfnSL60fv7iv3nxG+q42Tu0L/j13xcQAKhWr8I0UEmSjH7uDkBQgOkXL7+68pG5bj6uR3T2dG87fNDTo8D9EQCoVo/yTeAA964GkRwX/9vXf5o6JsGdB3Wd06WX9TrdEFexPivY39nT5c4hYWR89ZET4L56LcqXgNx4D2BezrTN//ArFfz0tzvs+0+f+Pov/+FWc+MQP/2tNts7e7a7c2AYMc4AoFrdfYqzgIJND/bilBH7xponvr/pOa3Gt3/TsvRbtx09+NbOL0ICA3/17dfHRscM8cV7TxbWNTa4bWwYDQIA1WpXXpgsNDDY1UfXabV/+9VvPL10hasP5FKdPV0f7st9d8+Onj7LDzY9t2np8qFj5nA43tyxxW3DwygRAKhWd1+fpd/q7yfzjzw0KNClh/bT63/56vcfe3iOS4/iUk1trR/uy303d0d7V+eiaTP+/sVvxUZE3ve7dhcevVxV4YbhwSkIANSsvasj0hw2eHtIYJDrDhpoMP7m9R/PmTTFdYdwqZr6W+/v2fnxgdw+S//Y6Jh/e+31uZOnDecbrTbrf37ygauHByciAFCztq4uNwcg2BT4x5/+fFJKmos+36WKrpa+uX1LwdnTdofd6O//6vqnvrn2SaP/cKfMfpK/t/r2TZeOEM5FAKBm7d3y6z246B5AUEDgmz/5mc/99Hc4HAVFZ/644/MzZSWSJGk0mrVzFry+6fnhXPP5Ukd31++2bHbZGOESBABq1tYpH4CQQOffAzAZDG/88KeTU9Od/smu02+17io88ub2z8uv1w5syUnL+PHzL01NH/+gH/WvH7zd1Nbq7AHCtQgA1KxN4UW1oUFOPgMwGQxv/vTnI/i56SmdPd2b8/Pe2bPjdnPTwJak2PgfPv3C0oceHsGnnS4t/rRgn1MHCHcgAFAzxQA49QxAp9X+6tuv+8pP/+b2tg/27nkvb8eXp0ehQUEvr17/1RVrZWdM3Zel3/rzP/3Be16wg+EjAFCzDsUAOPMM4O9f+taSGbOc+IEuUnWz7k87v9h65ICl/87LGk0GwwsrVr+8en2waeRF/PeP36lg4U/fRACgZm2d8ivS+PvpA/wNPcprRQzft9dv3Lh42eg/x6VKqq69s2fH9rve0KLX6Z9YsPi1DU9Hyc2SGr4DZ0+/s2eHM8YIDyAAULM25YeBQ4KCeppHG4C1cxa8tuHpUX6I6zgcjsPnz76544tTJZe+3KjTatfMWfDak0+PiYwe5efX1t/+8Ru/5uKP7yIAULO2LsU1KUMDg768/zkyE8el/uLr39ZoNKP5EBex2qw7jx/5044vrtRWf7lRo9EsmTHre089l+aMlem6+3q//5t/7ehm1U8fRgCgZm1dymcAo3sWzBwU/Ovv/Wj4D0m5TXdf72cF+97aufVmU+Pd26dnZn1/4/Mzxk9wylFsdvuPfv9rVn3wdQQAataufAZgDh75fWC9Tveb7/04IWq0l1Ccq7m97b28nR/s3X3P0w8zxk94bcMzsyZkO/FYP//TG/tPn3DiB8IjCADUrKWjTWlXZKh5xB/7w2e+OnPCxBF/u9PV1N96a+fWLw7l3/Ma5OmZWd954ulHsic793D/9emHnx5g1r8aEACoWWtnZ7/V6qeX+XceGTrC2S9zJk/9yorVoxuX05RVV/1597Ydxw5Zbba7t09Jz/zW408unDrD6Uf87Wcf/p4lH9SCAEDNHA5HU1ur7Jo20SOa/hgWEvIv3/quN9z4PXul5M3tnxcUnblnEk5OWsYr655yxY9+h8PxL++9xdu+1IQAQOUaWltkAxAV9sAB0Gg0//yt78ouL+o2Vpst7+TxN7dvKam+ds+unLSM7254es7kqa44rqXf+rM//v6Lwwdc8eHwFAIAlWtobZHdPoIHoJ559LEFU5z/m/Uw9Vj6thTsf2vX1usN9ffsmpya/tqGp+flDGvV/hFobG35q1//quhqqYs+H55CAKByDS3OCcDY6JgfPvMVZ4zogbV2dryft/v9vTtb2tvv2TVj/IRX1m+ck53juqNfqiz/7n/88tb/nlQKdSAAULmGtmbZ7RGhZp1W++XSCEPTaDQ/e/nVAH+DU4d2fzX1t97ZtX3Lof3dffc+tDw7O+eVdU8+lOXMyZ33sDvsf9q59T8/+aDfanXdUeBBBAAqV69wBqDTas3BIcNcwn7dvEUu/S17sOLKivdydw6e3iNJ0uzsnL966tmctAyXDuBmU+NP/vDrk5eLXXoUeBYBgMop3QOQJCkqLGw4AYgINf/ouRedOSZlVptt78nCt3ZvvVhx9Z5dAws5vLruyQnJqa4ew3u5O3/72UddvT0uPRA8jgBA5YYKQGhYqVR530/46QtfMzv7BTKDdfZ0f3pg37u5O+oaG+7ZpdVolz/8yCuPP5UxNsnVwzhVcukf3/6fq7U1rj4QvAEBgMoNEYBoc/h9v316ZtbKh+c6dUT3qmtseDd3x6cH9nX2dN+zS6/Tr5497xtrn0iJd8LybUO7Ulv9n59+mH/mJKt7ioMAQOWa29tsdrtOqx28KyrsPqtBaDXan7zwNdc99nWh4uqfd2/de7Jw8IX+QINxw6JHX1q59oHezD4y1+qu/+7zj/cUHrM7hnVLHKpBAKByVputtaM9Qm7ln6j7rQbx+LyF2ePSnD6kfqt1/5kT7+7ZefZKyeC9YcHBzz666vnlK91w3enslZJ39+zce+r4MGdDQWUIANSvoaVFPgBhQ10CMhkM33vqWSePpLVlc37uR/vzGuUuTMVHRr206vENC5e6er5pV19vbuHRD/fuuVRZ7tIDwcsRAKhfQ1vLeGnc4O2R5qEuAb20an1MeISzxnC+/Mp7uTtzTx6TnVOfPjbx5dXrVz0yV69z4X+SDofjXHnZ5wX7dhceY4YPJAIAESjdB5Y9LRhgDgp+ceWa0R966Ks9kiRNz8z6+ponFkyZ7tIF5spvXN9TeHTHsUPVt+pcdxT4HAIA9VOa7D/EKwG+turxoADTaA56u7lpc37ex/l5skfXaDQLp07/+ponpmVkjeYoQ+js6T5RfPHwxaIj54puNN67fBAgEQCIoLFN/rUwJoPRZDAMXmUhLDj42WUrR3Ysu8NeWHzxk/y9+06fsNpkrvZoNdplMx/59vqN6WMTR3aIoZXfuH7g7MnCSxdOlRazhAOGRgCgfkM87hsRau6uv33Pxm+s3RBoDHjQo9xqavzsYP5nBXtvKqybZjIYNix89KVVj8c5dWan1Wa9XFV5rrzs3NXSwuKLgxeMA5QQAKhfU/tQAaj93wGINIc9vXTF8D/cZrcfOnf2kwO5h86dVZpMaQ4Kfn75ymcfXRU2ihcR362hteX81bKiq2Xny8uKKyvueRMkMEwEAOrXOOQZwD1bnl+2apizMG81NX52cN+nBfuHWCo5LiLyxVWPP7lwqclgHOZoZTW0tpRUXSuuvFZSfa24smLwchHACBAAqN/Ql4Du/qPJYHh6yfKhP63H0pd/5uTWwwXHLp4b4vmptISxL69ev3r2vJHN7LzeUF9SNfDj/lpJ1bUhFrQARowAQP1aOzutNqvsD+Ko0NC7//j4/MWhQUGyH2Kz2wsvX9xx5ODeU4X3TKL30+vHREUnxcQnxcYlxcQmxcUnxsQlREUPf2Znv9Vafr2mtKaqtKqypKaqtLqyo7trmN8LjBgBgPo5HI6Wjg7ZV4BFhPzlDECr0X5lxerBX1NaVbn1aMGu40fqW5r1On1CdPT0mAnJsfFJMbFJsXGJsfFxEZF6ne6BhtRrsZTVVF2qLC++VlFSU1leWys7ZQhwKQIAITS1tsoH4K5LQItnzEyOjf/Lt7S1XrxWfrq0uKO7OyE65qcvfC0tISk5Nu5Bf9YPsNpsVbduFleWX75WUVxVcfHaVUs/P/HhYQQAQlCaCHR3AJ5fturuXWEhIQunzlg4deRvgW9pbz97peRUafHZK6Wl1ZXMyoe3IQAQQoPCfeCI/38PIDE6dmbWxLt3aTUyK0jf/0CtLWfKLheVlZ65UnK56hpr68ObEQAIoUnhYeAvV4N4cvGjI16Np7On68iFcweLzhwvvnC7uWmEQwTcjgBACEozQYMCTEZ/f6vNtm7eogf9zNr62wVFpwrOnmbRBfgoAgAhDPEoQHhI6MRxqbK3iAez2qwnii8eOHv60PkztYPWkAB8CwGAEIZ+FmzT4mVDf7vdYT93tSy38NiO44eb2+WvJgE+hwBACA3KP7VTx4x5ODtHaW/VzbpPC/ZuP3qovqXZNUMDPIYAQAhDnAHMnTx98CvjLf3W/LMnPsnfe7z4AjN5oFYEAEJo7Wi32e2Df9BLkjQtI/PuPza1tX64L/eDvTtbOjrcNTrAMwgAhGCz29s6O8JDQgfviouIGvgfZdVVf969befxw0zpgSAIAETR2NYqGwBJkq7UVr+x5ZPck8e42gOhEABBBRoDjAaDyfCXhe/bu7t6+npVvEBNY1trxtikwdsrbtSu++nr/OiHgAiAykWHhaeNGZsYGzcuLj4pNi42LNIcHBwWHOrvJ/9/vdVma+1ov93SfLu5qa6p4UZD/dWa6ivXa1SwHr3Sw8AajYaf/hATAVAbnVabnZI2NWN8TlrGlLTM2Ad8/axep4s0h0WawyaOS717e1tn5+Wqa2fKSoqulJy/WtbV1+vUUbuD0kSgyEEvBQMEQQBUwhwUPC9n6vwp0+dOnmoOcs6LZ+8WGhT0SPbkR7InS5JktdmKKysOnjtdcPZMaU2lr/z6rBSAYFOgv59exde+ACUEwLcZ/P0WTZ25du7CeTlTRvbqwRHQ63Q5aRk5aRl/9eSzt5ub8s+c3H700LnyMi8vgdKbgTUaTXiIeYj3+gJqRQB8VdqYhOeXrV45e26wKdCDw4gJj3jm0ceeefSx2vrb244c3Hb4QE39LQ+OZwiNCvcAJEmKCAklABAQAfA90zOzvr7miQVTpo94+WJXGBsd850nNr66/snC4ouf5O/de+r4EC9M94jhvxoeEAQB8CULpsz4/lPPjk8e5+mBKNJqtLOzc2Zn51Tfvvnu7h2fHdzXa7F4elB3KL0UTOI+MERFAHxDTlrGDzZ9ZeaEiff/Uu+QFBP3ty9+4ztPbHp/7+63d2/v7Ony9Iik5vY2u8Mu+54vzgAgppG89A5utmTGrI9+8Usf+un/pbCQkNc2bMr7jzdeXLlW6ckDt7HabO1d8h2KDJV/QhhQNwLgAwovXejs6fb0KEYuLDj4x8+9lPtvb2xcvGxkL9p1FqX7wJwBQEw6c+ZYT48B99FvtcZHRGWnpA3e1WuxfLhv9/7TJ240NgabAkMDg9w/vGEKMpkWTXto/pTppdWVnlpbf/nM2QlR0YO3N7e3bz18wP3jATyLAPiGm02NzyxdMXj79YbbZ0ovny69/MmBvLd3b9tx7HBPX29ybLzJaHT/IIcjJiz8iYVLI0JCz14ps1j73Xz0eTnT0scmDt4+0FE3DwbwOALgG5ra22ZNyB4z6LdXc1DwI9k5GxYufWnVutnZU4IDTceLz//rB29fvV6THBMfafbGKxtajWZSavr6+YtuNjWW36h156Gnj5+Qk5YxeLtGo/3jji3uHAngDQiAz6hvaVk7d6HSXr1ONyYq+qGsievnL35m6WP+fn5bDxdsO1IQFxH1oMsBuUegMWDFrNlpCWNPFF9021TRCUkpA6tZ3MPo7//fWz+zO7zrwQXA1QiAz6itvzVn8pS4Yfw0N/r7pyUkLp0xa/G0WRV1NZeulfvr/czBzl8gaPTSEhLXzJl/9UZt7W13PD+cHDtm8fSZg7drNJqP9u3p7vW9Fe6A0SAAvuRWU9MQJwGD6XW65Nj4jLFJBoO/xWptbms1BRi96vlhSZKCAkxr5swPNgUWFl909e/g0WHhq+fMl9217djBxlbFJ8UAVWIaqC85evHc2SslI/jGAH9DoMEYaQ47dO7s27u3V9++6fSxjYZGo/nqY2ve+bt/jI2IcOmBhloNIsQb75cALsUZgI8pq6l6ctHSkf0Wr9Vqk+Pi0xIS3tuz8728XYHGgMTYWO85IYiLiHx87qLSmirXXQ7S6bRffWyt7K7jl86X1lS56LiAdyIAPqahtSXGHD5R7pmAYfL3838kO2daRtYHebv+6Z03O3t60hMSA+56N6QHBRgMq2bP67daR3aic18Wq+XVdRtld527Wlp0pdQVBwW8FgHwPeeulj25aKnRf1Q/soNNpqUzZmWnpL6Xt/M/Nr9b19iQHBcfFhzirEGOmFajeSQ7JyYs4vCFIqffErDZ7V9Zsdrg7z9415XamqMXzzn3cICXIwC+p9diaeloXyI3m+VBxUdGP7loaWx45Mf7c9/cvuVy1bW4iMi4iKjRf/IoTRyXOj1zQv7ZU339Tp4hum7e4vAQmc7daKzPO3ncuccCvBwB8Ekl1ZXjE5NTxiSM/qM0Gk1W0rhNS5brtNptRwo25+cdu3g+NDAoOT7es7cHEqKiF+RM23/mpHNnZy5TWA2ipaPjC1aDgGAIgK8qLL6wdu7CQGOAUz7NT6+fNWHS+vmLWzs7Dp47s6vwSN6JY4EBprQxY7Vaj00Viwg1L5v1yMFzZ9s6O5z1mXMmT8kYmzR4e5/F8sFeVoOAWAiAr+q1WK5cr1k9Z54Tf08PCjAtnTFrZtbEy9WVV2tr9p0+sev4kcCAgPQEj2UgxBS4Ytbso5fODzGD84FMy8iakp45eLufXvc/2z93yiEAX0EAfFjt7VtWq012bYPRGBMV/dSiZdHm8PMVZbeam/afObn9yEGjvyFjbJLOExkwGQNWzJpz+EKRUxowPil59qQpg7cb/Pz/uGOL1WYb/SEAX0EAfNvZK6VJsXGy1zRGQ6vRZKekbVy8TJKki9eutnZ2FBSd/uLwgQCDMTMx2f1nAwEGw4qZsw9fKGpqV3yx+zAlRscufehh2V2fHtjX0e35N5cBbkMAfN7h82fnTJoSE+78Z2gNfv6PZOc8+tAj1bfqautvd/Z0FxSdzjt5LDwkNHXMWDffIh5owKELZ5tH14DIkNC18xbK7tpVeOR2c9NoPhzwLQTA51lttj0njs2dPCXKHOaKzw8PCX183sLslLSL5VfbujpbOtpzTxzLO3U8LDgkLUFmbX3XCTAYls54eO+p4+2j+D3daDA8s/Qx2V0Hz5+9Vnd9xJ8M+BwCoAaW/v59Z04umvaQ657kSo6L37RkRYDBcLHiar/V2tzelnvi2PFLFxJjYga/pcB1Ao0B83Om7yo80tvXN7JPcDjsL69eL7vrVEnxpWvloxgd4GMIgEr09PXuP3Ny4dQZ5iBXLfus02mnZ05Yv2Bxe1dXWU2VQ3LcbGrccujAuatl4+ITYsLCXXTce5iDg2dOmLTr2OF+m3UE397X3//NtRtk72YXV147WXJp1AMEfAYBUI/Onu5dhUdmZmW74n7AlwKNAYunz1w0bUblzbq6xnpJkmrrb31asK+0piojISk8JNR1h/5STFh4VnLKruNHHA7HCL594+JlQSbT4O1VN28UFJ0e9egAn0EAVKW3r2/nsUNZSeOSYuNdeqAoc/j6+YszxiYVV5a3d3VJknSt7vrH+3Ov19+ekJwSbAp06dElSUqKjQsMMB25UDSC7101e77s+crtluZdxw+PemiAzyAAatNvs+05cXtJ+lAAABAGSURBVDTQGJCTluHqiTqpY8ZuWrLCZDRerCi3WPsdkqO0puqj/bvbOjuzU9JGuVzdfU1Jz7zd3Hi5qvJBv3HRtJnj4mQC2dnT88mBvc4YGuAbCIAK2R2OIxeKKm5cn5cz1V/v59Jj6XTa6ZlZGxYsae/uKqupcjgcNrv9fPmVj/fnORyOiSmpfjq9644+L2faqdLiusaGB/quWRMmTRyXOni7w25/e/d2Jw0N8AEEQLXKb9TuO31iakZmlNnlt2dNRuPiaTOXTJ9VefPGjYZ6SZIs1v7C4gtbDuUHGgNc9+yYTqudlzNt29GDPX0PsGDcxJS0mVkTB283+Pv/Yeunzhsd4O0IgJq1dLR/fjDfbrdNzchywyoOkWbzuvmLxycmX6681tbVKUlSV29PQdHp3BPHosPCU+LHuOKSVKAxICspZcexQ8O/IZyaMHbBlOmDt+u02vdyd/ZanLwANeC1CIDK2R32UyXF+UWnJo5Lc89MzZQxCU8vXR4ZYi6uujbwi3lLR/vuwqNHLhQlx8XHRzr/oYGx0TEOSTP8GZyxEZErH54ru2vb0YJRPmkM+BACIISmttbPCvbXNTbkpKabnLSC9BC0Wu2k1PRNS1f46fwuV1b0W62SJN1ubtpyKP/StYqMxKSIUCe/gX3G+KyzZSXXG+qH88UhgYFPLlwqu2vfqRO19bedOjTAexEAUTgkR0l15ScH9mokKSs5xU/vwnuzA/z1+pkTsp9ctLTPYimtqbTb7ZIkVd+q27w/r/pWXWbSuNDAIGcdS6PRPDxh0ucH8y39/ff9Yr1O95UVa2R3Hbt4rqy22lmjArwcARCLxdp/vPjCJ/l5PX2WiSmprp4jJElSgME4f8r0dfMX9/T1lVRVOiSHQ3Jcqa3+aF/u7eamCckpQQEyz2SNQJDJFBMRse9U4X2/ss9qeWXdU7K7zpeX8Wp4iIMAiKjXYjlVcumzg/v7LP1pCYkBBtdO2JckKdhkWjTtoYVTZ1yvvz1wjcXusBdXVny0f09nT/eEcalOeWggMzG5/EZtxY3aob/MZrN/9bE1Bj+ZV8OX1VbzaniIgwCIq6ev98Tli+/n7bzZ1Dg2OtYNqzhEh4U/Pm/h1Mys8uu1Da0tkiRZbbaiK6Uf78+z2qwTUlL9R31hataEyZ8f3HffmTzr5i+SXTjven393mGcQwDqQABEZ7XZiisrPty3e2AZnOS4eFdfF0qMjt24+NG0hLGlVZUDs0Ut1v6Tly99kp9ndziyx6XpdboRf3iAwRARat5/+sTQX7Z85hzZRUxbOtq38mp4CIMA4I6G1paCotPv5+68er1Wr9ePiYzR6Vz16IBGo0lLSNy0ZHmUOaystrqzp1uSpF6L5filC1uPHAgymTLGJo342bHMxOQzZZeHnhE0N0f+1fC9/f0f8mp4CIMA4H/pt1mv1FbvOn74/bxd1+quW23WmPAI2cvlo6fTaielpj+7dGVEaGhZTVVXb48kSZ093flnTu08eigwICB9bOIIMqDRaKakZX5asNdmsyt9jdKr4XVa7Zs7tjzoEQEfRQAgz9LfX1pTlXvi2Fu7th6/dL6xrdVkMEaGmp3+NK9Op52cmvHM0sfCQ0JKa6q6e3slSWrr6sw/c3L7kYMmQ0BG4gNnwBwc3G+1niotVvqCrKRxj2TnDN5u8PN7c8fnQ5QDUBMCgPuwOxx1jQ2FxRc+zs/bnJ9XfqO2p6832BQYLLek/ojpdbqctMxnHl0RGhRUUl3Z09cnSVJ7d9eBs6e2HT5o9PdPS0h6oHsDk1LTvzh0YOCsYrDEmNilM2YN3q7RaD45sLeju3tkfwvAtxAAPIDu3t6S6sq9pwrf3r19c37eqdJLdU2NGo0UGRrmlLWG/HT6qenjX1i+Ojku/kpN9cAt4o7uroKi05sP5PX09WUmJhv9h3U9yk+vNwcF7z9zUnZvRKh57dyFsrt2HT98u6V5pH8DwJcQAIxQd29v1c2645cufH5w/zu7t5+4fKny5vWO7u4Ag2GUL4TR6bTjE5OfXrpiTHT0tbobrZ0dkiT19PWdKrn00f7c9q7OtITEwID7L2iRmZhUcPbMwHzTewQYjc8sXSH7XQVFpytv3hjN+AFfoUlaM9vTY4DahAUHTxiXNjE5ZeK41IkpqWNGsQCc3WHPLTz+39s/Lauu+nKjn16/8uG5zy1bOSk1fehvP3H50ov/9HcyIwwJOfbG27Lf8vO3/vDxvtwRDxjwIQQALhcSGDQheVxmYvL4pHETksaljEnQP+BbYhwOx/HiC2dKL1+qrCiurGhqax3YPikl7dllKx+bNdfgr/jswov/9HcnLt+7UKhGo7nw9mbZYfz2s49/9/lHDzQ8wEcRALibn16fnpCUlTRufHLy+MRx45OSH3Q5oFtNjZerrhVXVgz0wO6wPzF/8bp5i9MSZK5nnikref4f/nrw9oL/ejMmPGLw9s37c3/2pz880HgAH+XyJSGBe/RbrZerKi5XVUgH72yJDgufOC5lQnJaWkJCWkJS6v1eHRMbERkbEbl4+syBPza0thRXVuw5ccxyxJIyJmHe5Kl3Lzc9PTNrTnbO0Uvn7/mQxrZW2QBEmsNG87cDfAgBgOfVtzTXtzQfOHt64I/hIaGTU9MnpabnpKZPSk0Pud+q0VHmsIVTZyycOmPgj01trZZ+q7/fX/5tv/bkM4MDIHtzWCIAEAkBgNdpbm8rKDo9sDaRRqNJio2bnJI+KS19SnpmVlLKfeebDn7bzJT0zBnjJ5wuvXz3xsbWVtlvjyIAEAYBgFdzOBxVN+uqbtZtO3pQkqRAgzEnPfPh7Mmzs3OyksdpNcN9+OClVevuCYDSGUBEiFmj0Qz/DcOA7yIA8CVdfb3HLp0/dun8v0vvhgUHz5wwaVZW9uzJU5Ji4ob+xoVTp4+LG3P3BP/GdvkzAH8/fUhgYFtnpzPHDXglHgSDr+q1WCpu1B48d+a93J15p443tbWGmIKUruBrNBo/vX7gstKAuIjIxx6eI/vFWw8faO5od8mgAW9CAKAGze1tp0qKP87P3XIov66hXqfTxUVE3bOEXOqYsR/u29PXf+ddMSGmoA0Kr4bfe6pwmO+XB3waAYCqdHR3n6+4su1IwacH9t5qaow2h0ea79wT1ut09c3NFyquDvzRT697YcVq2Q85cr7o6vUaN40Y8BxXvfED8KyG1pZ3cnes++vXN/zNDz/I2zXwzpmNi5d9+QVfPk482OB5RIAqEQCo3OWqin98+38Wfufln/3xDY1WOzV9/MD27r6+7r5e2W+JCHX565EBb8AsIAihq693c37epwf2hd/1w725vd0UZRz8xQQAguAMAAKxO+yNd03/V7oKFBHCJSAIgQBAXE3tbbLbuQcAQRAAiKtJYTWIiBAuAUEIBADiauQSEMRGACCuZoVLQAZ/vwd9RQHgiwgAxNWksByQxG0AiIEAQFxDBYDbABAAAYC4mtrkLwFJPAoAMRAAiGvIAHAJCOpHACCutq5Oq80quyuSMwAIgABAXA6Ho7ldft3/8GACAPUjABCa4moQXAKCAAgAhKb0KAABgAgIAITWoPgwMJeAoH4EAEJTmggUaSYAUD8CAKEpXQIKCgg0+Pu5eTCAmxEACE0pAJIkhQWHuHMkgPsRAAhN6R6AJEmRIWHuHAngfgQAQmM9OIiMAEBozSwHBIERAAitub3N7rDL7uIMAKpHACA0q83W3tUlu4tHAaB6BACia1S4CsQlIKgeAYDolG4DhHMGALUjABCd0npwkdwDgNoRAIiuqYPlgCAoAgDRKZ0BmINDdFr+A4Ga8e8bolNaD06n1YYGBbt5MIA7EQCITukMQOI2ANSOAEB0TcrrwTETFOpGACC6Ic4AIkI4A4CaEQCITukegMQZANSOAEB0PZa+rr5e2V3MBIW6EQBA+WFgzgCgagQA4GFgCIoAAIovhjQH8VZIqBkBAKSWznbZ7eZgHgSDmhEAQGrt6JTdHsaTwFA1AgBIbZ0dstuDTCaWA4KK8Y8bULwEpNVoQwID3TwYwG0IACC1dspfApK4DwxVIwCA1NohfwlIkiQztwGgXgQAkFoVLgFJkmQODnLnSAB3IgAAl4AgKAIASK0dHQ6HQ3ZXWDABgGoRAECy2qxdvT2yu8xBXAKCahEAQJKUrwJxCQgqRgAASVK+D8xqEFAxAgBIkiS1KcwE5RIQVIwAAJIkSS0Kq0FwCQgqRgAASZKkVqUAcAkI6kUAAElSXg+OJ4GhYgQAkCRJammXD4CfXh9oDHDzYAD3IACAJClfApIkiQVBoVYEAJAkSWrv7lLaFWwiAFAnAgBIkiR1dncr7Qo2mdw5EsBtCAAgSZLU0a24HhxnAFArAgBIkiR19MivBSRxBgD1IgCAJElSZ5fiPYAgzgCgUgQAkCRJ6urrtdpssrtCOAOAShEA4I4uhatAnAFArQgAcIfSTNCQAM4AoE4EALijUyEAnAFArQgAcEdHt/wloJBAzgCgTgQAuEPpUYCgAM4AoE4EALijo0f+YWAuAUGtCABwR4fSTWCmgUKlCABwR3uX0hkAAYA6EQDgjs4e+TMAk8Go1+ndPBjADQgAcIfSNFBJkoICeCcMVIgAAHe0Ki8HZDQY3DkSwD0IAHBH1c0bstu7+nobW1vdPBjADQgAcEf59dpzV8sGb996MN9qs7p/PICrEQDgL/7P7/69tv723VtOlxb/20fveGo8gEtpktbM9vQYAC8SaAzYsGDJ5PSMfqv1+MXzuwqPKC0TDfg6AgAAguISEAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKAIAAAIigAAgKD+H2nXH4ImynpVAAAAAElFTkSuQmCC";
const BRAIN_MCP = { type:"url", url:"https://microsoft365.mcp.claude.com/mcp", name:"microsoft365" };

// ─── PALETTE ─────────────────────────────────────────────────────────────────
const C = {
  // Main content
  ground:       "#F4F1E8",
  panel:        "#FBF9F3",
  panel2:       "#EFEADD",
  panelWarm:    "#EDE5D4",
  line:         "#DBD3C2",
  lineSoft:     "#E8E2D6",
  ivory:        "#1E2A20",
  chipText:     "#3A2810",
  sand:         "#6E5B3E",
  bark:         "#8A6F52",
  forest:       "#3E6B4A",
  forestDim:    "#E3EBE2",
  muted:        "#7C8478",
  // Header (dark forest)
  headerBg:     "#243E1A",
  headerBorder: "#3E5C30",
  headerSand:   "#CDBFA3",
  // Footer
  footerBg:     "#EFEADD",
  footerBorder: "#CBB99A",
  // Drawer — LIGHT (matches main content palette)
  drawerBg:     "#FBF9F3",
  drawerPanel:  "#F4F1E8",
  drawerLine:   "#DBD3C2",
  drawerActive: "#3E6B4A",
  drawerActiveBg:"#E3EBE2",
  drawerText:   "#1E2A20",
  drawerMuted:  "#7C8478",
  drawerSand:   "#6E5B3E",
  // Scrim
  scrim:        "rgba(20,30,18,0.45)",
};

const DISCLAIMER = "Licensed clinician support only. GCC.ai is not a substitute for professional judgment, formal assessment or clinical supervision.";
const COPYRIGHT_FULL = "© Jonathan Porter, MA, LPC-S, NCC · Greenleaf Counseling and Consulting, LLC · All rights reserved. This tool is intended solely for use by the licensed clinician to whom it is issued. Unauthorised use is prohibited.";

const BUILD = {
  version:     "0.1.0-beta.1",
  name:        "GCC.ai Clinical Resource",
  stage:       "Internal Beta",
  released:    "June 2026",
  build:       "20260627.001",
  description: "Internal beta release of GCC.ai. Features, content, and clinical reference data are under active development and subject to change. Additional features currently in development.",
};

// ─── OFFLINE BRAIN CACHE LAYER ──────────────────────────────────────────────
// Fetches /gcc-brain.json from the same origin on launch.
// On success: stores in Cache API (persists offline).
// On failure / offline: falls back to embedded CLINICAL_KB.
// To update the brain: update gcc-brain.json only — no app redeployment needed.
// Migration path: same JSON structure is directly indexable by Azure AI Search.

const BRAIN_FILE_URL  = "/gcc-brain.json";
const BRAIN_CACHE_KEY = "gcc-brain-v1";

async function fetchAndCacheBrain() {
  if (!("caches" in window)) return null;
  try {
    const res = await fetch(BRAIN_FILE_URL, { cache: "no-cache" });
    if (res.ok) {
      const cache = await caches.open(BRAIN_CACHE_KEY);
      await cache.put(BRAIN_FILE_URL, res.clone());
      const data = await res.json();
      return Array.isArray(data.entries) ? data.entries : null;
    }
  } catch {
    try {
      const cache  = await caches.open(BRAIN_CACHE_KEY);
      const cached = await cache.match(BRAIN_FILE_URL);
      if (cached) {
        const data = await cached.json();
        return Array.isArray(data.entries) ? data.entries : null;
      }
    } catch { /* no cache available */ }
  }
  return null;
}

function mergeBrain(remote) {
  if (!remote || !remote.length) return CLINICAL_KB;
  const embeddedIds = new Set(CLINICAL_KB.map(e => e.id));
  const extras  = remote.filter(e => !embeddedIds.has(e.id));
  const updated = CLINICAL_KB.map(e => {
    const override = remote.find(r => r.id === e.id);
    return override ? { ...e, ...override } : e;
  });
  return [...updated, ...extras];
}

function searchBrainIn(kb, query) {
  if (!kb || !query || query.length < 3) return [];
  const terms = query.toLowerCase().split(/\s+/).filter(t => t.length > 2);
  return kb.map(entry => {
    let score = 0;
    const text = (entry.title + " " + (entry.keywords||[]).join(" ") + " " + entry.content).toLowerCase();
    for (const t of terms) {
      if ((entry.keywords||[]).some(k => k.includes(t) || t.includes(k))) score += 3;
      if (entry.title.toLowerCase().includes(t)) score += 2;
      if (text.includes(t)) score += 1;
    }
    return { ...entry, score };
  }).filter(e => e.score > 0).sort((a,b) => b.score-a.score).slice(0,3);
}

const SUGGESTIONS = [
  "Differential for OCD vs. GAD presentation",
  "DSM-5-TR criteria for clinical perfectionism features",
  "ERP protocol framework for contamination-focused OCD",
  "Rule-outs for adult ADHD vs. anxiety-driven inattention",
];

// ─── CLINICAL BRAIN ──────────────────────────────────────────────────────────
const CLINICAL_KB = [

  // ── DSM-5-TR CRITERIA ────────────────────────────────────────────────────
  {
    id: "dsm-ocd", category: "dsm5tr", title: "OCD — DSM-5-TR Criteria",
    keywords: ["ocd","obsessive","compulsive","obsession","compulsion","intrusive","ritual"],
    content: `OCD DSM-5-TR (300.3 / F42.2):
A. Obsessions (recurrent, persistent, intrusive thoughts/urges/images; person attempts to suppress or neutralize) AND/OR compulsions (repetitive behaviors or mental acts driven by rigid rules or aimed at reducing distress; excessive or not realistically connected to feared outcome).
B. Time-consuming (>1 hr/day) OR clinically significant distress/impairment.
C. Not attributable to substances/medical condition.
D. Not better explained by another mental disorder.
Specifiers: good/fair insight | poor insight | absent insight/delusional | tic-related.
Rule-outs: GAD (ego-syntonic worry vs ego-dystonic obsessions), OCPD (pervasive pattern vs discrete symptoms), BDD (appearance-focused), hoarding disorder, trichotillomania, excoriation disorder.
Assess with: Y-BOCS (severity), dimensional OCD scale (symptom domains).`
  },
  {
    id: "dsm-gad", category: "dsm5tr", title: "GAD — DSM-5-TR Criteria",
    keywords: ["gad","generalized anxiety","worry","anxious","anxiety disorder","apprehensive"],
    content: `GAD DSM-5-TR (300.02 / F41.1):
A. Excessive anxiety and worry about multiple domains, occurring more days than not ≥6 months.
B. Difficulty controlling worry.
C. ≥3 of: restlessness/keyed up, easily fatigued, difficulty concentrating, irritability, muscle tension, sleep disturbance. (Only 1 required in children.)
D. Clinically significant distress or functional impairment.
E. Not attributable to substances/medical condition.
F. Not better explained by another mental disorder.
Rule-outs: OCD (circumscribed vs diffuse), PTSD (trauma-linked), panic disorder, SAD, illness anxiety. Key distinction from OCD: GAD worry is ego-syntonic, realistic-domain focused; OCD obsessions are ego-dystonic, often absurd/unacceptable.
Assess with: GAD-7 (≥10 = moderate; ≥15 = severe), PSWQ.`
  },
  {
    id: "dsm-panic", category: "dsm5tr", title: "Panic Disorder — DSM-5-TR Criteria",
    keywords: ["panic","panic disorder","panic attack","palpitation","chest","derealization","agoraphobia"],
    content: `Panic Disorder DSM-5-TR (300.01 / F41.0):
A. Recurrent unexpected panic attacks (abrupt surge peaking within minutes; ≥4 of: palpitations, sweating, trembling, shortness of breath, choking, chest pain, nausea, dizziness, chills/heat, paresthesias, derealization/depersonalization, fear of losing control, fear of dying).
B. ≥1 month of: persistent worry about additional attacks or their consequences OR significant maladaptive behavioral change.
C. Not attributable to substances/medical condition or another mental disorder.
Rule-outs: Medical (arrhythmia, hyperthyroidism, pheochromocytoma), substance-induced, specific phobia (cue-triggered only), SAD, PTSD.`
  },
  {
    id: "dsm-adhd", category: "dsm5tr", title: "ADHD — DSM-5-TR Criteria (Adult)",
    keywords: ["adhd","attention","hyperactivity","inattention","impulsivity","concentration","focus","distracted"],
    content: `ADHD DSM-5-TR (314.01 / F90.x) — Adult presentation:
A. ≥5 symptoms (not 6 as in children) of Inattention AND/OR Hyperactivity-Impulsivity, present ≥6 months, inconsistent with developmental level:
Inattention: careless mistakes, sustaining attention, not listening, not following through, disorganization, avoids sustained mental effort, loses things, distracted by extraneous stimuli, forgetful.
Hyperactivity-Impulsivity: fidgeting, leaving seat, running/climbing (or restlessness in adults), unable to engage quietly, "on the go," talks excessively, blurts answers, can't wait turn, interrupts.
B. Several symptoms present before age 12.
C. Present in ≥2 settings.
D. Clear interference with functioning.
E. Not exclusively during psychosis; not better explained by another disorder.
Specifiers: Combined / Predominantly Inattentive / Predominantly Hyperactive-Impulsive; mild/moderate/severe; in partial remission.
Key adult differential: GAD/OCD-driven inattention is secondary to worry/obsessions; ADHD inattention is pervasive and predates anxiety onset. GAD-7 and PSWQ help quantify anxiety load.`
  },
  {
    id: "dsm-mdd", category: "dsm5tr", title: "MDD — DSM-5-TR Criteria",
    keywords: ["depression","mdd","major depressive","depressed mood","anhedonia","sad","hopeless","worthless","suicidal"],
    content: `MDD DSM-5-TR (296.xx / F32.x or F33.x):
A. ≥5 of the following in same 2-week period; ≥1 must be (1) or (2):
(1) Depressed mood most of the day, nearly every day
(2) Markedly diminished interest/pleasure
(3) Significant weight/appetite change
(4) Insomnia or hypersomnia
(5) Psychomotor agitation or retardation
(6) Fatigue/loss of energy
(7) Worthlessness/excessive guilt
(8) Diminished concentration/indecisiveness
(9) Recurrent thoughts of death/suicidal ideation/attempt
B. Clinically significant distress or impairment.
C. Not attributable to substances/medical condition.
D. Not better explained by schizoaffective disorder; not superimposed on schizophrenia spectrum.
E. No manic/hypomanic episode (→ Bipolar if present).
Specifiers: anxious distress, melancholic, atypical, psychotic, catatonic, peripartum, seasonal; single/recurrent; mild/moderate/severe; with/without psychotic features; in partial/full remission.`
  },
  {
    id: "dsm-perfectionism", category: "dsm5tr", title: "Clinical Perfectionism — DSM-5-TR Context",
    keywords: ["perfectionism","clinical perfectionism","fmps","standards","mistakes","criticism","failure","self-critical"],
    content: `Clinical perfectionism is a transdiagnostic feature, not a standalone DSM-5-TR diagnosis. Code the primary disorder with perfectionism noted as a maintaining factor.
Relevant diagnostic contexts:
- OCD: perfectionism/symmetry/incompleteness dimension (harm-avoidance, "not just right" experiences, ego-dystonic).
- OCPD (301.4 / F60.5): pervasive preoccupation with orderliness, perfectionism, control (ego-syntonic); ≥4 criteria including perfectionism that interferes with task completion, excessive devotion to work, inflexibility about ethics/morality, hoarding, reluctance to delegate, miserliness, rigidity.
- GAD: worry about performance, mistakes, evaluation.
- MDD: self-criticism, failure rumination.
- Eating disorders: perfectionism as core cognitive feature.
FMPS (Frost Multidimensional Perfectionism Scale) subscales: Concern over Mistakes, Personal Standards, Parental Criticism, Parental Expectations, Doubting of Actions, Organization. CM and DA subscales are most clinically relevant.
CBT approach: behavioral experiments targeting feared consequences of imperfection; self-compassion work; broadening self-evaluation domains (Shafran et al.).`
  },
  {
    id: "dsm-social-anxiety", category: "dsm5tr", title: "Social Anxiety Disorder — DSM-5-TR Criteria",
    keywords: ["social anxiety","sad","social phobia","embarrassment","humiliation","scrutiny","performance"],
    content: `Social Anxiety Disorder DSM-5-TR (300.23 / F40.10):
A. Marked fear/anxiety about social situations where exposed to possible scrutiny (conversations, meeting new people, being observed eating/drinking, performing in front of others).
B. Fears acting in ways that will be negatively evaluated (embarrassed, humiliated, rejected, offensive).
C. Social situations almost always provoke fear/anxiety.
D. Social situations avoided or endured with intense distress.
E. Fear is out of proportion to actual threat and sociocultural context.
F. Persistent ≥6 months.
G–I. Distress/impairment, not substances/medical, not better explained by another disorder.
Specifier: performance only.
Rule-outs: panic disorder (unexpected vs cued), agoraphobia, specific phobia, separation anxiety, OCD, PTSD, autism spectrum.`
  },
  {
    id: "dsm-adjustment", category: "dsm5tr", title: "Adjustment Disorder — DSM-5-TR Criteria",
    keywords: ["adjustment","stressor","life change","adjustment disorder","situational","reactive","work stress"],
    content: `Adjustment Disorder DSM-5-TR (309.xx / F43.xx):
A. Emotional/behavioral symptoms in response to identifiable stressor(s), developing within 3 months of stressor onset.
B. Clinically significant: marked distress out of proportion to severity/context of stressor (cultural context considered) OR significant functional impairment.
C. Does not meet criteria for another mental disorder; is not an exacerbation of a preexisting disorder.
D. Does not represent normal bereavement.
E. Once stressor (or its consequences) terminates, symptoms do not persist >6 months.
Subtypes: with depressed mood (F43.21), with anxiety (F43.22), with mixed anxiety/depressed mood (F43.23), with disturbance of conduct (F43.24), with mixed disturbance of emotions and conduct (F43.25), unspecified (F43.20).`
  },

  // ── ICD-10-CM CODES ──────────────────────────────────────────────────────
  {
    id: "icd-anxiety", category: "icd10", title: "ICD-10-CM — Anxiety Disorders",
    keywords: ["icd","code","anxiety","gad","panic","phobia","f41","f40"],
    content: `Anxiety Disorder ICD-10-CM codes:
F41.1  Generalized Anxiety Disorder
F41.0  Panic Disorder
F41.3  Other mixed anxiety disorders
F41.8  Other specified anxiety disorders
F41.9  Anxiety disorder, unspecified
F40.00 Agoraphobia, unspecified
F40.01 Agoraphobia with panic disorder
F40.02 Agoraphobia without panic disorder
F40.10 Social Anxiety Disorder (Social Phobia), unspecified
F40.11 Social Anxiety Disorder, generalized
F40.8  Other phobic anxiety disorders
F40.9  Phobic anxiety disorder, unspecified
F93.0  Separation anxiety disorder of childhood (used for adults per DSM-5)`
  },
  {
    id: "icd-ocd", category: "icd10", title: "ICD-10-CM — OCD Spectrum",
    keywords: ["icd","code","ocd","obsessive","compulsive","f42","bdd","hoarding","trichotillomania","f63","f45"],
    content: `OCD & Related Disorders ICD-10-CM codes:
F42.2  OCD (unspecified — most commonly used)
F42.3  Hoarding disorder
F42.4  Excoriation (skin-picking) disorder
F42.8  Other obsessive-compulsive related disorders (includes BDD)
F42.9  OCD, unspecified
F45.22 Body Dysmorphic Disorder (alternative code; confirm payer)
F63.2  Kleptomania
F63.3  Trichotillomania (hair-pulling disorder)
Tic-related OCD: add tic disorder code (F95.x) alongside F42.2.
Insight specifiers coded via 7th character or clinical documentation (ICD-10-CM doesn't have separate codes for insight levels — document in the note).`
  },
  {
    id: "icd-depressive", category: "icd10", title: "ICD-10-CM — Depressive Disorders",
    keywords: ["icd","code","depression","mdd","f32","f33","depressive","dysthymia","f34"],
    content: `Depressive Disorders ICD-10-CM codes:
F32.0  MDD, single episode, mild
F32.1  MDD, single episode, moderate
F32.2  MDD, single episode, severe without psychotic features
F32.3  MDD, single episode, severe with psychotic features
F32.4  MDD, single episode, in partial remission
F32.5  MDD, single episode, in full remission
F32.9  MDD, single episode, unspecified
F33.0  MDD, recurrent, mild
F33.1  MDD, recurrent, moderate
F33.2  MDD, recurrent, severe without psychotic features
F33.3  MDD, recurrent, severe with psychotic features
F33.41 MDD, recurrent, in partial remission
F33.42 MDD, recurrent, in full remission
F33.9  MDD, recurrent, unspecified
F34.1  Dysthymic disorder (Persistent Depressive Disorder)
F34.81 Disruptive mood dysregulation disorder
F34.89 Other specified depressive disorder (includes situational depression)`
  },
  {
    id: "icd-adhd", category: "icd10", title: "ICD-10-CM — ADHD",
    keywords: ["icd","code","adhd","attention","hyperactivity","f90"],
    content: `ADHD ICD-10-CM codes:
F90.0  ADHD, predominantly inattentive type
F90.1  ADHD, predominantly hyperactive type
F90.2  ADHD, combined type
F90.8  Other ADHD
F90.9  ADHD, unspecified
Note: DSM-5-TR specifiers (mild/moderate/severe, in partial remission) are documented in the clinical note; ICD-10-CM does not have separate codes for these. Use F90.2 for combined, F90.0 for predominantly inattentive (most common adult presentation).`
  },
  {
    id: "icd-adjustment", category: "icd10", title: "ICD-10-CM — Adjustment & Stress Disorders",
    keywords: ["icd","code","adjustment","f43","ptsd","acute stress","work stress"],
    content: `Adjustment & Stress-Related ICD-10-CM codes:
F43.10 PTSD, unspecified
F43.11 PTSD, acute
F43.12 PTSD, chronic
F43.20 Adjustment disorder, unspecified
F43.21 Adjustment disorder with depressed mood
F43.22 Adjustment disorder with anxiety
F43.23 Adjustment disorder with mixed anxiety and depressed mood
F43.24 Adjustment disorder with disturbance of conduct
F43.25 Adjustment disorder with mixed disturbance of emotions and conduct
F43.29 Adjustment disorder with other symptoms
F43.0  Acute stress reaction
F43.81 Prolonged grief disorder
F43.89 Other reactions to severe stress`
  },
  {
    id: "icd-personality", category: "icd10", title: "ICD-10-CM — Personality Disorders",
    keywords: ["icd","code","personality","ocpd","f60","obsessive compulsive personality"],
    content: `Personality Disorders ICD-10-CM codes (relevant to practice):
F60.5  OCPD (Obsessive-Compulsive Personality Disorder)
F60.0  Paranoid personality disorder
F60.1  Schizoid personality disorder
F60.2  Antisocial personality disorder
F60.3  Borderline personality disorder
F60.4  Histrionic personality disorder
F60.6  Avoidant personality disorder
F60.7  Dependent personality disorder
F60.81 Narcissistic personality disorder
F60.89 Other specific personality disorders
F60.9  Personality disorder, unspecified
OCPD vs OCD: OCPD (F60.5) is a pervasive characterological pattern (ego-syntonic); OCD (F42.2) involves discrete episodes of ego-dystonic obsessions/compulsions. Both can co-occur — code separately.`
  },

  // ── ERP / ACT / CBT PROTOCOLS ────────────────────────────────────────────
  {
    id: "protocol-erp", category: "protocol", title: "ERP — Exposure & Response Prevention Protocol",
    keywords: ["erp","exposure","response prevention","hierarchy","habituation","inhibitory learning","ocd protocol","compulsion prevention"],
    content: `ERP for OCD (Abramowitz/Twohig model, ~16 sessions):
Core mechanism: Inhibitory learning — new non-threat associations form when feared stimuli are contacted without avoidance/compulsions, not simply through habituation.
Structure:
- Sessions 1-2: Psychoeducation (OCD model, obsession→anxiety→compulsion→relief cycle), treatment rationale, Y-BOCS baseline.
- Session 3: Build exposure hierarchy (SUDs 30–100); identify all avoidance/compulsion variations.
- Sessions 4-12: Graduated exposures, in-session + homework; response prevention (no compulsions, including mental rituals); process post-exposure expectancy violations.
- Sessions 13-15: High-hierarchy items; relapse prevention; generalization.
- Session 16: Termination; maintenance plan.
Key ERP principles:
• Approach triggers without avoidance across contexts, time, internal states (variability → stronger inhibitory learning).
• Eliminate all compulsions including mental neutralizing, reassurance-seeking, checking.
• Focus on expectancy violation ("What did you expect? What actually happened?") rather than anxiety reduction.
• "Surf the urge" — tolerate uncertainty and discomfort rather than eliminating it.
Common OCD exposure domains: contamination, harm/checking, symmetry/ordering, forbidden thoughts (sexual, religious, aggressive), "not just right" experiences.
ACT integration: Defusion from obsessions as thoughts rather than facts; values-based committed action despite obsessions.`
  },
  {
    id: "protocol-act", category: "protocol", title: "ACT — Acceptance & Commitment Therapy Core Processes",
    keywords: ["act","acceptance","defusion","values","committed action","psychological flexibility","hexaflex","mindfulness","present moment"],
    content: `ACT Core Processes (Hexaflex):
1. Acceptance: Willingness to have difficult private events (thoughts, feelings, urges) without struggling to change their form/frequency. Counter to experiential avoidance. Language: "making room for" anxiety rather than fighting it.
2. Cognitive Defusion: Seeing thoughts as thoughts ("I'm having the thought that…"), not literal truths. Techniques: milk/milk/milk, leaves on a stream, thoughts as sounds, naming the story ("there goes the perfectionism story").
3. Present Moment Awareness: Flexible contact with the here and now. Mindfulness exercises, grounding, noticing observer self.
4. Self-as-Context (Observer Self): Noticing the consistent "I" that observes all experiences — not fused with content. Chessboard metaphor, observing self meditation.
5. Values Clarification: What matters to the person, not what feels good in the moment. Values ≠ goals (ongoing directions vs achievable endpoints). Tombstone exercise, values card sort, bull's-eye worksheet.
6. Committed Action: Flexible, values-guided behavior change including traditional behavioral techniques (goal setting, habit formation, exposure). Willingness + values = effective action.
ACT in OCD/anxiety: Defusion from obsessions; acceptance of uncertainty as a values-consistent willingness; committed action = ERP; self-as-context in separating self from OCD narrative.
ACT in perfectionism: Defusion from self-critical thoughts; values broader than performance outcomes; acceptance of imperfection as workable.`
  },
  {
    id: "protocol-cbt-anxiety", category: "protocol", title: "CBT for Anxiety — Core Model & Techniques",
    keywords: ["cbt","cognitive behavioral","cognitive restructuring","thought record","behavioral experiment","safety behavior","anxiety cbt","avoidance"],
    content: `CBT Anxiety Model (Clark/Beck):
Core: Threat appraisal (overestimation of probability and cost of threat) + safety behaviors that maintain anxiety by preventing disconfirmation.
Key techniques:
Cognitive:
• Thought records (situation → automatic thought → emotion → evidence for/against → balanced thought)
• Probability overestimation: "What's the actual base rate? What would you tell a friend?"
• Catastrophizing/decatastrophizing: "If the worst happened, could you cope?"
• Cognitive continuum: rating fears on a 0-100 scale to break all-or-nothing thinking (clinical perfectionism application)
Behavioral:
• Behavioral experiments: explicit hypothesis testing (better than thought challenging alone)
• Safety behavior elimination: identify, reduce, eliminate behaviors that prevent disconfirmation
• Activity scheduling (for depression/low motivation)
• Worry postponement: designated 15-min worry period to contain GAD worry
• Stimulus control for insomnia comorbidity
GAD-specific: Intolerance of uncertainty model (Dugas) — worry as attempt to control uncertain future; uncertainty exposure (Behar/Borkovec) alongside behavioral experiments.
Perfectionism-specific CBT (Shafran): Broaden self-evaluation domains; behavioral experiments targeting "if I make a mistake, X will happen"; self-compassion component.`
  },
  {
    id: "protocol-mi", category: "protocol", title: "Motivational Interviewing — Core Techniques",
    keywords: ["motivational interviewing","mi","ambivalence","change talk","readiness","rollback","reflective listening","oars"],
    content: `Motivational Interviewing (Miller & Rollnick):
OARS:
• Open questions: elicit the client's own perspective and change talk
• Affirmations: genuine recognition of strengths/efforts
• Reflective listening: simple, complex, double-sided reflections
• Summaries: collecting, linking, transitional
Change talk (DARN-CAT): Desire, Ability, Reason, Need, Commitment, Activation, Taking steps. Reflect and amplify.
Sustain talk: Reflect without amplifying; explore ambivalence.
Principles: Express empathy, develop discrepancy (current behavior vs values/goals), roll with resistance (avoid argumentation), support self-efficacy.
Application in clinical perfectionism/OCD: MI in early sessions to address ambivalence about giving up compulsions or performance standards; explore cost-benefit of perfectionism; elicit values-based reasons for change before beginning ERP or CBT.`
  },

  // ── ASSESSMENT INSTRUMENTS ───────────────────────────────────────────────
  {
    id: "assess-gad7", category: "assessment", title: "GAD-7 — Generalized Anxiety Disorder Scale",
    keywords: ["gad7","gad-7","anxiety screening","anxiety severity","spitzer"],
    content: `GAD-7 (Spitzer et al., 2006):
Purpose: Screen for GAD; assess anxiety severity across disorders.
Items: 7 items rated 0 (not at all) to 3 (nearly every day) over past 2 weeks.
Scoring:
0-4   Minimal anxiety (monitor)
5-9   Mild anxiety (watchful waiting; psychoeducation)
10-14 Moderate anxiety (consider treatment)
15-21 Severe anxiety (active treatment indicated)
≥10 = sensitivity 89%, specificity 82% for GAD.
Also performs well as a screen for panic disorder, social anxiety, PTSD.
Clinical use: Baseline + ongoing to track treatment response. A 5-point change is clinically meaningful. Use alongside PSWQ when GAD is primary presentation. Freely available, no copyright restriction for clinical use.
Administration: Self-report, ~2 min.`
  },
  {
    id: "assess-ybocs", category: "assessment", title: "Y-BOCS — Yale-Brown Obsessive Compulsive Scale",
    keywords: ["ybocs","y-bocs","ocd severity","obsessions","compulsions","yale brown"],
    content: `Y-BOCS (Goodman et al., 1989):
Purpose: Gold-standard OCD severity measure; tracks treatment response.
Structure: 10 items — 5 obsession subscale (time, interference, distress, resistance, control) + 5 compulsion subscale. Each item 0-4.
Scoring (Total 0-40):
0-7    Subclinical
8-15   Mild
16-23  Moderate
24-31  Severe
32-40  Extreme
Preceded by symptom checklist (obsession/compulsion categories present).
Clinically meaningful change: ≥35% reduction from baseline = treatment response; ≥25% = partial response.
CY-BOCS for children/adolescents.
Y-BOCS-II: Updated version with revised wording; same scoring structure. Preferred for new assessments.
Administration: Clinician-administered (~20 min) or self-report (YBOCS-SR). Clinician version is more reliable for moderate-severe presentations.`
  },
  {
    id: "assess-pswq", category: "assessment", title: "PSWQ — Penn State Worry Questionnaire",
    keywords: ["pswq","penn state worry","worry","gad measure","pathological worry"],
    content: `PSWQ (Meyer et al., 1990):
Purpose: Measures trait worry; assesses pathological worry central to GAD; differentiates GAD worry from non-pathological worry.
Items: 16 items rated 1 (not at all typical) to 5 (very typical). 11 positive + 5 reverse-scored items.
Scoring (Total 16-80):
<45    Non-pathological worry (low/average)
45-59  Moderate worry
≥60    High worry (clinically significant; consistent with GAD range)
Common clinical cut-off: ≥45 for elevated worry; ≥65 for severe GAD-range worry.
Use: Baseline + treatment tracking. Sensitive to change. Use alongside GAD-7 — PSWQ captures the trait worry construct more specifically; GAD-7 captures symptom severity/impairment.
Differentiates: GAD worry (high PSWQ) from OCD obsessions (may have lower PSWQ with high Y-BOCS), PTSD intrusions, depression rumination.
Administration: Self-report, ~5 min. No cost for clinical use.`
  },
  {
    id: "assess-fmps", category: "assessment", title: "FMPS — Frost Multidimensional Perfectionism Scale",
    keywords: ["fmps","frost","perfectionism scale","concern over mistakes","doubting","personal standards","parental criticism"],
    content: `FMPS (Frost et al., 1990):
Purpose: Multidimensional assessment of perfectionism; identifies clinically relevant perfectionism domains.
Items: 35 items rated 1 (strongly disagree) to 5 (strongly agree).
Subscales:
CM  Concern over Mistakes (9 items) — most clinically relevant; associated with psychopathology
PS  Personal Standards (7 items) — high standards not inherently pathological
DA  Doubting of Actions (4 items) — clinically relevant; overlaps with OCD
PE  Parental Expectations (5 items)
PC  Parental Criticism (4 items)
O   Organization (6 items) — not considered part of maladaptive perfectionism core
Total score: 35-175 (exclude O subscale for clinical perfectionism total).
Clinical interpretation:
CM >25 — elevated concern over mistakes (clinically significant)
DA >12 — elevated doubting (consider OCD overlap)
PS >28 — high personal standards
High CM + DA with moderate PS: consistent with maladaptive clinical perfectionism.
High PS with low CM/DA: potentially adaptive perfectionism — less treatment urgency.
Use alongside Y-BOCS when OCD/perfectionism overlap is present. Freely available for clinical/research use.`
  },

];

function searchBrain(query) {
  if (!query || query.length < 3) return [];
  const terms = query.toLowerCase().split(/\s+/).filter(t => t.length > 2);
  return CLINICAL_KB.map(entry => {
    let score = 0;
    const text = (entry.title + " " + entry.keywords.join(" ") + " " + entry.content).toLowerCase();
    for (const t of terms) {
      if (entry.keywords.some(k => k.includes(t) || t.includes(k))) score += 3;
      if (entry.title.toLowerCase().includes(t)) score += 2;
      if (text.includes(t)) score += 1;
    }
    return { ...entry, score };
  }).filter(e => e.score > 0).sort((a, b) => b.score - a.score).slice(0, 3);
}

function brainPreview(q) {
  const hits = searchBrain(q);
  return hits.length ? `Referencing: ${hits[0].title.split("—")[0].trim()}` : "Synthesising clinical criteria";
}

// ─── ICD-10 INDEX ────────────────────────────────────────────────────────────
const ICD_INDEX = {
  "F41.1":  { name:"Generalized Anxiety Disorder", code:"F41.1", dsm:"300.02", criteria:"Excessive anxiety/worry ≥6 months, ≥3 symptoms (restlessness, fatigue, concentration, irritability, muscle tension, sleep disturbance), difficult to control, causes significant distress/impairment.", notes:"GAD-7 ≥10 = moderate. PSWQ ≥60 = high worry. Rule out OCD, PTSD, panic disorder." },
  "F41.0":  { name:"Panic Disorder", code:"F41.0", dsm:"300.01", criteria:"Recurrent unexpected panic attacks + ≥1 month persistent concern about attacks or maladaptive behavioral change. Panic attack: ≥4 symptoms peaking within minutes (palpitations, sweating, trembling, SOB, choking, chest pain, nausea, dizziness, chills/heat, paresthesias, derealization, fear of losing control, fear of dying).", notes:"Rule out medical causes: arrhythmia, hyperthyroidism, pheochromocytoma." },
  "F42.2":  { name:"Obsessive-Compulsive Disorder", code:"F42.2", dsm:"300.3", criteria:"Obsessions (recurrent intrusive thoughts/urges/images + attempts to suppress/neutralize) AND/OR compulsions (repetitive behaviors/mental acts aimed at reducing distress). Time-consuming >1 hr/day OR causes significant distress/impairment.", notes:"Specify: good/fair insight | poor insight | absent insight/delusional | tic-related. Y-BOCS gold standard. Rule out OCPD, GAD, BDD." },
  "F42.3":  { name:"Hoarding Disorder", code:"F42.3", dsm:"300.3", criteria:"Persistent difficulty discarding possessions regardless of actual value. Perceived need to save items, distress at discarding. Results in cluttered living areas compromising their use. Causes significant distress/impairment.", notes:"Specify: with excessive acquisition; good/fair/poor/absent insight." },
  "F42.4":  { name:"Excoriation (Skin-Picking) Disorder", code:"F42.4", dsm:"698.4", criteria:"Recurrent skin picking → skin lesions. Repeated attempts to stop. Causes significant distress or functional impairment. Not attributable to substances, medical condition, or better explained by another mental disorder.", notes:"Rule out trichotillomania, stereotypic movement disorder, NSSI." },
  "F42.8":  { name:"Body Dysmorphic Disorder", code:"F42.8", dsm:"300.7", criteria:"Preoccupation with ≥1 perceived defects/flaws in physical appearance that are not observable or appear slight to others. Repetitive behaviors (mirror checking, excessive grooming, skin picking, reassurance seeking) OR mental acts (comparing appearance) in response to concerns. Causes significant distress/impairment.", notes:"Specify: with muscle dysmorphia; insight level. Rule out eating disorder if weight-focused." },
  "F40.10": { name:"Social Anxiety Disorder", code:"F40.10", dsm:"300.23", criteria:"Marked fear/anxiety about social situations involving possible scrutiny. Fears negative evaluation (embarrassment, humiliation, rejection). Social situations almost always provoke fear. Situations avoided or endured with intense distress. Persistent ≥6 months. Distress/impairment present.", notes:"Specify: performance only. Rule out panic disorder (unexpected vs cued), PTSD, autism spectrum." },
  "F40.00": { name:"Agoraphobia, unspecified", code:"F40.00", dsm:"300.22", criteria:"Marked fear/anxiety about ≥2 of: public transport, open spaces, enclosed spaces, standing in line/crowds, being outside home alone. Situations feared because escape difficult or help unavailable if panic-like symptoms occur. Almost always provoke fear. Avoided, require companion, or endured with intense distress. Persistent ≥6 months.", notes:"Code separately from panic disorder. F40.01 = with panic disorder." },
  "F90.0":  { name:"ADHD, Predominantly Inattentive", code:"F90.0", dsm:"314.00", criteria:"≥5 inattention symptoms ≥6 months (adults): careless mistakes, sustaining attention, not listening, not following through, disorganization, avoids sustained mental effort, loses things, distracted, forgetful. Several symptoms before age 12. Present in ≥2 settings. Clear interference with functioning.", notes:"Most common adult ADHD presentation. Key differential: GAD/OCD inattention is secondary to worry; ADHD is pervasive and predates anxiety." },
  "F90.1":  { name:"ADHD, Predominantly Hyperactive", code:"F90.1", dsm:"314.01", criteria:"≥5 hyperactivity-impulsivity symptoms ≥6 months (adults): fidgeting, leaving seat, restlessness (vs running/climbing in children), unable to engage quietly, 'on the go,' talks excessively, blurts answers, can't wait turn, interrupts. Several symptoms before age 12.", notes:"Less common in adult-presenting cases. Often Combined type in childhood." },
  "F90.2":  { name:"ADHD, Combined Type", code:"F90.2", dsm:"314.01", criteria:"Meets criteria for both Predominantly Inattentive (≥5 symptoms) and Predominantly Hyperactive-Impulsive (≥5 symptoms) presentations. Symptoms present ≥6 months, before age 12, in ≥2 settings, with clear functional impairment.", notes:"Most impairing ADHD presentation. Common childhood pattern, may shift to predominantly inattentive in adulthood." },
  "F32.0":  { name:"Major Depressive Disorder, Single Episode, Mild", code:"F32.0", dsm:"296.21", criteria:"≥5 MDD symptoms in same 2-week period (must include depressed mood or anhedonia): depressed mood, anhedonia, weight/appetite change, insomnia/hypersomnia, psychomotor agitation/retardation, fatigue, worthlessness/guilt, concentration, suicidal ideation. Mild: few symptoms beyond minimum, minor impairment.", notes:"No prior manic/hypomanic episode. Rule out bipolar disorder, substances, medical condition." },
  "F32.1":  { name:"Major Depressive Disorder, Single Episode, Moderate", code:"F32.1", dsm:"296.22", criteria:"≥5 MDD symptoms in same 2-week period. Moderate: symptoms/impairment between mild and severe.", notes:"Consider PHQ-9 ≥10 for moderate range. Assess suicide risk." },
  "F32.2":  { name:"Major Depressive Disorder, Single Episode, Severe", code:"F32.2", dsm:"296.23", criteria:"≥5 MDD symptoms in same 2-week period. Severe: most symptoms present, marked interference with functioning.", notes:"Assess for psychotic features. PHQ-9 ≥20. Evaluate level of care." },
  "F33.0":  { name:"Major Depressive Disorder, Recurrent, Mild", code:"F33.0", dsm:"296.31", criteria:"≥2 MDD episodes (separated by ≥2 consecutive months without full criteria). Current episode meets mild severity.", notes:"Assess for bipolar with longitudinal history. Consider maintenance treatment." },
  "F33.1":  { name:"Major Depressive Disorder, Recurrent, Moderate", code:"F33.1", dsm:"296.32", criteria:"≥2 MDD episodes (separated by ≥2 months without full criteria). Current episode meets moderate severity.", notes:"Recurrence risk increases with number of prior episodes." },
  "F33.2":  { name:"Major Depressive Disorder, Recurrent, Severe", code:"F33.2", dsm:"296.33", criteria:"≥2 MDD episodes. Current episode meets severe severity without psychotic features.", notes:"Evaluate inpatient/intensive outpatient level of care. Safety assessment." },
  "F34.1":  { name:"Persistent Depressive Disorder (Dysthymia)", code:"F34.1", dsm:"300.4", criteria:"Depressed mood most of the day, more days than not, ≥2 years. ≥2 of: poor appetite/overeating, insomnia/hypersomnia, low energy, low self-esteem, poor concentration, hopelessness. Never without symptoms >2 months. Significant distress/impairment.", notes:"May co-occur with MDD ('double depression'). Chronic course warrants maintenance focus." },
  "F43.21": { name:"Adjustment Disorder with Depressed Mood", code:"F43.21", dsm:"309.0", criteria:"Emotional/behavioral symptoms within 3 months of identifiable stressor. Marked distress disproportionate to stressor severity OR significant functional impairment. Does not meet criteria for another mental disorder. Not normal bereavement. Symptoms resolve within 6 months of stressor termination.", notes:"Most commonly coded adjustment disorder. Specify stressor in documentation." },
  "F43.22": { name:"Adjustment Disorder with Anxiety", code:"F43.22", dsm:"309.24", criteria:"As above with predominant symptoms of nervousness, worry, jitteriness, or separation anxiety.", notes:"" },
  "F43.23": { name:"Adjustment Disorder with Mixed Anxiety and Depressed Mood", code:"F43.23", dsm:"309.28", criteria:"As above with combination of depressed mood and anxiety symptoms.", notes:"Most common presentation when both affect domains are involved." },
  "F60.5":  { name:"Obsessive-Compulsive Personality Disorder", code:"F60.5", dsm:"301.4", criteria:"Pervasive pattern of preoccupation with orderliness, perfectionism, and mental/interpersonal control, at expense of flexibility and efficiency, ≥4 of: preoccupied with details/rules/lists/order/organization; perfectionism interferes with task completion; excessive devotion to work; overconscientious/inflexible about ethics/morality; unable to discard worthless objects; reluctant to delegate; miserly spending style; rigidity and stubbornness.", notes:"Ego-syntonic (vs OCD which is ego-dystonic). Can co-occur with OCD — code both. FMPS useful for perfectionism severity." },
  "F60.3":  { name:"Borderline Personality Disorder", code:"F60.3", dsm:"301.83", criteria:"Pervasive instability in interpersonal relationships, self-image, and affects with marked impulsivity, ≥5 of: frantic efforts to avoid real/imagined abandonment; unstable intense relationships; identity disturbance; impulsivity in ≥2 self-damaging areas; recurrent suicidal/self-mutilating behavior; affective instability; chronic emptiness; intense anger; transient stress-related paranoia/dissociation.", notes:"DBT is first-line evidence-based treatment. Assess suicide risk carefully." },
  "F63.3":  { name:"Trichotillomania (Hair-Pulling Disorder)", code:"F63.3", dsm:"312.39", criteria:"Recurrent pulling out of one's hair resulting in hair loss. Repeated attempts to stop. Causes significant distress or functional impairment. Not attributable to another medical condition or mental disorder.", notes:"Habit reversal training is first-line. Rule out alopecia areata." },
  "F93.0":  { name:"Separation Anxiety Disorder", code:"F93.0", dsm:"309.21", criteria:"Developmentally inappropriate and excessive fear/anxiety concerning separation from attachment figures, ≥3 of: distress when separation occurs/anticipated; worry about losing attachment figures; worry about events causing separation; reluctance to go out; fear of being alone; reluctance to sleep away; nightmares about separation; physical complaints on separation. Persistent ≥4 weeks (children) / ≥6 months (adults). Causes significant distress/impairment.", notes:"DSM-5 extended to adults. Differentiate from panic disorder, agoraphobia, GAD." },
};

// ─── SESSION HELPERS ─────────────────────────────────────────────────────────
const HISTORY_KEY = "gcc_ai_sessions_v1";
function loadSessions() { try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]"); } catch { return []; } }
function saveSessions(s) { try { localStorage.setItem(HISTORY_KEY, JSON.stringify(s)); } catch {} }
function newSession() { return { id: Date.now(), label: new Date().toLocaleDateString("en-US", { month:"short", day:"numeric", hour:"2-digit", minute:"2-digit" }), messages: [], created: Date.now() }; }

// ─── HAMBURGER ICON ──────────────────────────────────────────────────────────
function Hamburger({ color = "#F3EFE4", size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none" aria-hidden="true">
      <rect y="3"  width="18" height="1.6" rx="0.8" fill={color} />
      <rect y="8.2" width="18" height="1.6" rx="0.8" fill={color} />
      <rect y="13.4" width="18" height="1.6" rx="0.8" fill={color} />
    </svg>
  );
}

// ─── MARKDOWN RENDERER ───────────────────────────────────────────────────────
function Md({ text }) {
  if (!text) return null;
  const lines = text.split("\n");
  const els = []; let i = 0;
  while (i < lines.length) {
    const ln = lines[i];
    if (/^# /.test(ln))   { els.push(<h1 key={i} style={md.h1}>{ln.replace(/^# /,"")}</h1>); i++; continue; }
    if (/^## /.test(ln))  { els.push(<h2 key={i} style={md.h2}>{ln.replace(/^## /,"")}</h2>); i++; continue; }
    if (/^### /.test(ln)) { els.push(<h3 key={i} style={md.h3}>{ln.replace(/^### /,"")}</h3>); i++; continue; }
    if (/^---/.test(ln))  { els.push(<hr key={i} style={md.hr} />); i++; continue; }
    if (/^[-*] /.test(ln)) {
      const items = [];
      while (i < lines.length && /^[-*] /.test(lines[i])) { items.push(<li key={i} style={md.li}>{iMd(lines[i].replace(/^[-*] /,""))}</li>); i++; }
      els.push(<ul key={`u${i}`} style={md.ul}>{items}</ul>); continue;
    }
    if (/^\d+\. /.test(ln)) {
      const items = [];
      while (i < lines.length && /^\d+\. /.test(lines[i])) { items.push(<li key={i} style={md.li}>{iMd(lines[i].replace(/^\d+\. /,""))}</li>); i++; }
      els.push(<ol key={`o${i}`} style={md.ul}>{items}</ol>); continue;
    }
    if (/^`{3}/.test(ln)) {
      const code = []; i++;
      while (i < lines.length && !/^`{3}/.test(lines[i])) { code.push(lines[i]); i++; }
      els.push(<pre key={i} style={md.pre}><code>{code.join("\n")}</code></pre>); i++; continue;
    }
    if (!ln.trim()) { els.push(<div key={i} style={{height:10}} />); i++; continue; }
    els.push(<p key={i} style={md.p}>{iMd(ln)}</p>); i++;
  }
  return <div>{els}</div>;
}
function iMd(text) {
  const parts = []; const re = /(\*\*.*?\*\*|\*.*?\*|`.*?`)/g; let last = 0, m;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const t = m[0];
    if (t.startsWith("**"))     parts.push(<strong key={m.index}>{t.slice(2,-2)}</strong>);
    else if (t.startsWith("*")) parts.push(<em key={m.index}>{t.slice(1,-1)}</em>);
    else                        parts.push(<code key={m.index} style={md.inlineCode}>{t.slice(1,-1)}</code>);
    last = m.index + t.length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}
const md = {
  h1:  { fontFamily:"'DM Serif Display',serif", fontSize:20, fontWeight:400, margin:"16px 0 6px", color:C.forest, lineHeight:1.2 },
  h2:  { fontFamily:"'DM Serif Display',serif", fontSize:16.5, fontWeight:400, margin:"14px 0 5px", color:C.forest },
  h3:  { fontFamily:"'DM Serif Display',serif", fontSize:14, fontWeight:400, margin:"10px 0 4px", color:C.bark },
  p:   { fontSize:14, lineHeight:1.7, margin:"0 0 7px", color:C.ivory },
  ul:  { paddingLeft:18, margin:"3px 0 9px" },
  li:  { fontSize:14, lineHeight:1.65, marginBottom:3, color:C.ivory },
  hr:  { border:"none", borderTop:`1px solid ${C.drawerLine}`, margin:"14px 0" },
  pre: { background:C.panel2, border:`1px solid ${C.line}`, borderRadius:8, padding:"10px 12px", overflowX:"auto", margin:"8px 0 10px", fontSize:13 },
  inlineCode: { background:C.panel2, borderRadius:4, padding:"1px 5px", fontSize:12.5 },
};

// ─── COPY BUTTON ─────────────────────────────────────────────────────────────
function CopyBtn({ text }) {
  const [done, setDone] = useState(false);
  function copy() { navigator.clipboard?.writeText(text).then(() => { setDone(true); setTimeout(() => setDone(false), 1800); }); }
  return <button onClick={copy} style={s.copyBtn} className="gl-copy">{done ? "✓ Copied" : "Copy"}</button>;
}

// ─── CHAT FORMATTER ──────────────────────────────────────────────────────────
function Fmt({ text }) {
  return text.split("\n").map((ln, i) => {
    const line = ln.replace(/\*\*(.+?)\*\*/g, "<b>$1</b>");
    if (/^#{1,3}\s/.test(ln)) return <h4 key={i} style={s.h4} dangerouslySetInnerHTML={{ __html: line.replace(/^#{1,3}\s/, "") }} />;
    if (/^[-*]\s/.test(ln)) return <div key={i} style={s.bullet}><span style={s.dot}>·</span><span dangerouslySetInnerHTML={{ __html: line.replace(/^[-*]\s/, "") }} /></div>;
    if (!ln.trim()) return <div key={i} style={{ height: 8 }} />;
    return <p key={i} style={s.p} dangerouslySetInnerHTML={{ __html: line }} />;
  });
}

// ─────────────────────────────────────────────────────────────────────────────
// DRAWER PANELS
// ─────────────────────────────────────────────────────────────────────────────

// ── CHAT HISTORY ─────────────────────────────────────────────────────────────
function ChatPanel({ sessions, activeId, onLoad, onNew, onDelete }) {
  return (
    <div style={dp.panel}>
      <button style={dp.primaryBtn} onClick={onNew}>New Conversation</button>
      {sessions.length === 0 && (
        <p style={dp.emptyNote}>No saved sessions. Start a conversation and it will appear here.</p>
      )}
      {sessions.map(sess => (
        <div key={sess.id}
          style={{ ...dp.sessRow, ...(sess.id === activeId ? dp.sessActive : {}) }}
          onClick={() => onLoad(sess.id)} className="dr-row">
          <div style={dp.sessInfo}>
            <span style={dp.sessLabel}>{sess.label}</span>
            <span style={dp.sessDate}>{new Date(sess.created).toLocaleDateString("en-US", { month:"short", day:"numeric" })}</span>
          </div>
          <button style={dp.rowX} onClick={e => { e.stopPropagation(); onDelete(sess.id); }}>×</button>
        </div>
      ))}
    </div>
  );
}

// ── ICD-10 SEARCH ─────────────────────────────────────────────────────────────
function IcdPanel({ onOpenInMain }) {
  const [query, setQuery]     = useState("");
  const [result, setResult]   = useState(null);
  const [notFound, setNotFound] = useState(false);
  const inputRef = useRef(null);
  useEffect(() => { setTimeout(() => inputRef.current?.focus(), 120); }, []);

  function search(raw) {
    const q = (raw || query).trim().toUpperCase();
    setNotFound(false); setResult(null);
    if (!q) return;
    if (ICD_INDEX[q]) { setResult(ICD_INDEX[q]); return; }
    const partial = Object.values(ICD_INDEX).filter(e => e.code.startsWith(q) || e.code.replace(".", "").startsWith(q.replace(".", "")));
    if (partial.length === 1) { setResult(partial[0]); return; }
    if (partial.length > 1)  { setResult({ multi: partial }); return; }
    const ql = raw.toLowerCase();
    const byName = Object.values(ICD_INDEX).filter(e =>
      e.name.toLowerCase().includes(ql) || (e.notes && e.notes.toLowerCase().includes(ql)) || e.criteria.toLowerCase().includes(ql)
    );
    if (byName.length === 1) { setResult(byName[0]); return; }
    if (byName.length > 1)  { setResult({ multi: byName }); return; }
    setNotFound(true);
  }

  return (
    <div style={dp.panel}>
      {/* Search bar */}
      <div style={dp.searchBar}>
        <input ref={inputRef} className="dr-in" style={dp.searchInput} value={query}
          onChange={e => { setQuery(e.target.value); if (!e.target.value.trim()) { setResult(null); setNotFound(false); } }}
          onKeyDown={e => e.key === "Enter" && search(query)}
          placeholder="Code (F42.2) or diagnosis name…" />
        <button style={dp.searchBtn} onClick={() => search(query)}>Search</button>
      </div>

      {/* Quick index */}
      {!result && !notFound && (
        <div style={dp.codeIndex}>
          {Object.values(ICD_INDEX).map(e => (
            <button key={e.code} className="dr-row" style={dp.codeRow}
              onClick={() => { setQuery(e.code); search(e.code); }}>
              <span style={dp.codeTag}>{e.code}</span>
              <span style={dp.codeName}>{e.name}</span>
            </button>
          ))}
        </div>
      )}

      {/* Multi-match */}
      {result?.multi && (
        <div style={dp.resultWrap}>
          <p style={dp.resultMeta}>{result.multi.length} matches</p>
          {result.multi.map(r => (
            <button key={r.code} className="dr-row" style={dp.codeRow} onClick={() => setResult(r)}>
              <span style={dp.codeTag}>{r.code}</span>
              <span style={dp.codeName}>{r.name}</span>
            </button>
          ))}
        </div>
      )}

      {/* Single result — compact preview + open in main */}
      {result && !result.multi && (
        <div style={dp.resultWrap}>
          <button style={dp.backLink} onClick={() => setResult(null)}>← Back</button>
          <div style={dp.resultHeader}>
            <span style={dp.resultCode}>{result.code}</span>
            <span style={dp.resultDsm}>DSM-5-TR {result.dsm}</span>
          </div>
          <h3 style={dp.resultName}>{result.name}</h3>
          <p style={dp.resultPreview}>{result.criteria.slice(0, 160)}…</p>
          <button style={dp.openMainBtn} onClick={() => onOpenInMain(result)}>
            View full criteria →
          </button>
        </div>
      )}

      {notFound && <p style={dp.emptyNote}>No match found. Try a partial code (e.g. F42) or a diagnosis keyword.</p>}
    </div>
  );
}

// ── REFERENCE VIEWER ──────────────────────────────────────────────────────────
function ReferencePanel({ onOpenInMain }) {
  const [loading, setLoading] = useState(false);
  const [err, setErr]         = useState("");
  const fileRef = useRef(null);

  async function loadFile(f) {
    if (!f) return;
    setErr(""); setLoading(true);
    try {
      const isPdf = f.type === "application/pdf" || f.name.toLowerCase().endsWith(".pdf");
      if (isPdf) {
        // PDF: create an object URL for native browser rendering
        const url  = URL.createObjectURL(f);
        const name = f.name.replace(/\.pdf$/i, "");
        // Also read as base64 so the AI can query it if requested
        const b64 = await new Promise((res, rej) => {
          const r = new FileReader();
          r.onload = () => res(r.result.split(",")[1]);
          r.onerror = () => rej(new Error("read failed"));
          r.readAsDataURL(f);
        });
        onOpenInMain({ type: "pdf", url, name, filename: f.name, dataB64: b64 });
      } else {
        // Text / Markdown: read as plain text for Md renderer
        const text = await f.text();
        const name = f.name.replace(/\.md$|\.txt$|\.markdown$/i, "");
        onOpenInMain({ type: "text", text, name, filename: f.name });
      }
    } catch { setErr("Could not open file. Supported formats: PDF, Markdown (.md), plain text (.txt)."); }
    finally { setLoading(false); }
  }

  return (
    <div style={dp.panel}>
      <div style={dp.refIntroBox}>
        <p style={dp.refIntroText}>Open clinical reference documents in full-screen view.</p>
        <p style={dp.refIntroSub}>Supports PDF, Markdown (.md), and plain text (.txt). Treatment protocols, assessment guides, supervision notes, and diagnostic frameworks open directly from this device or any connected cloud service.</p>
        <p style={{...dp.refIntroSub, marginTop:5}}>PDF files can also be queried by the AI — use the Ask button after opening.</p>
      </div>
      <button style={dp.primaryBtn} onClick={() => fileRef.current?.click()} disabled={loading}>
        {loading ? "Opening…" : "Open Document"}
      </button>
      {err && <p style={{ ...dp.emptyNote, color: "#B85C45", marginTop: 10 }}>{err}</p>}
      <input ref={fileRef} type="file" accept=".md,.txt,.markdown,.pdf,application/pdf"
        style={{ display: "none" }} onChange={e => loadFile(e.target.files?.[0])} />
    </div>
  );
}

// ── SETTINGS ─────────────────────────────────────────────────────────────────
function SettingsPanel({ source, setSource, localFiles, setLocalFiles, addLocalFiles, brainCount, brainSource }) {
  const fileRef = useRef(null);
  return (
    <div style={dp.panel}>

      <div style={dp.settingGroup}>
        <p style={dp.settingLabel}>Legal & Copyright</p>
        <div style={dp.copyrightBox}>
          <p style={dp.copyrightText}>{COPYRIGHT_FULL}</p>
        </div>
      </div>

      <div style={dp.settingGroup}>
        <p style={dp.settingLabel}>Beta Information</p>
        <div style={dp.betaBox}>
          <div style={dp.betaHeader}>
            <span style={dp.betaBadge}>BETA</span>
            <span style={dp.betaVersion}>{BUILD.version}</span>
          </div>
          <p style={dp.betaName}>{BUILD.name}</p>
          <div style={dp.betaMeta}>
            <div style={dp.betaRow}>
              <span style={dp.betaKey}>Stage</span>
              <span style={dp.betaVal}>{BUILD.stage}</span>
            </div>
            <div style={dp.betaRow}>
              <span style={dp.betaKey}>Released</span>
              <span style={dp.betaVal}>{BUILD.released}</span>
            </div>
            <div style={dp.betaRow}>
              <span style={dp.betaKey}>Build</span>
              <span style={dp.betaVal}>{BUILD.build}</span>
            </div>
          </div>
          <p style={dp.betaDesc}>{BUILD.description}</p>
        </div>
      </div>

      <div style={dp.settingGroup}>
        <p style={dp.settingLabel}>Reference Source</p>
        {[
          ["local",  "Local",      "Attach PDFs for AI to reference on every query"],
          ["off",    "Integrated", "Use integrated clinical reference only"],
        ].map(([key, title, desc]) => (
          <button key={key} className="dr-row"
            style={{ ...dp.sourceRow, ...(source === key ? dp.sourceActive : {}) }}
            onClick={() => setSource(key)}>
            <div style={dp.sourceText}>
              <span style={dp.sourceTitle}>{title}</span>
              <span style={dp.sourceDesc}>{desc}</span>
            </div>
            {source === key && <span style={dp.sourceTick}>✓</span>}
          </button>
        ))}
      </div>

{source === "local" && (
        <div style={dp.settingGroup}>
          <p style={dp.settingLabel}>PDFs Attached to Every Query</p>
          <p style={{...dp.settingHint, marginBottom:8}}>These PDFs are sent to the AI on every query. Use for documents you want the AI to always reference — different from the Reference viewer, which opens documents for reading and on-demand querying.</p>
          <button style={dp.outlineBtn} onClick={() => fileRef.current?.click()}>Add PDFs</button>
          <input ref={fileRef} type="file" accept="application/pdf" multiple
            style={{ display: "none" }} onChange={e => addLocalFiles(e.target.files)} />
          {localFiles.length > 0 && (
            <div style={{ marginTop: 10 }}>
              {localFiles.map(f => (
                <div key={f.name} style={dp.fileRow}>
                  <span style={dp.fileName}>{f.name}</span>
                  <button style={dp.rowX}
                    onClick={() => setLocalFiles(prev => prev.filter(x => x.name !== f.name))}>×</button>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <div style={dp.settingGroup}>
        <p style={dp.settingLabel}>Cloud Reference Library</p>
        <div style={{...dp.brainInfo, opacity:0.65}}>
          <p style={dp.brainTitle}>Coming in a future release</p>
          <p style={dp.brainBody}>Cloud drive integration — search and retrieve reference PDFs directly from your secure cloud drive — is planned for a future update alongside the semantic search upgrade. Use the Reference viewer to open cloud-stored documents individually in the meantime.</p>
        </div>
      </div>

      <div style={dp.settingGroup}>
        <p style={dp.settingLabel}>Integrated Clinical Reference — Active</p>
        <div style={dp.brainInfo}>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
            <p style={{...dp.brainTitle,margin:0}}>Integrated Clinical Reference</p>
            <span style={{fontSize:10,fontWeight:700,letterSpacing:"1.5px",
              color:brainSource==="remote"?C.forest:C.muted,
              background:brainSource==="remote"?C.forestDim:C.panel2,
              border:`1px solid ${brainSource==="remote"?C.forest:C.line}`,
              borderRadius:5,padding:"2px 7px"}}>
              {brainSource==="remote"?"UPDATED":brainSource==="cached"?"CACHED":"EMBEDDED"}
            </span>
          </div>
          <p style={dp.brainBody}>{brainCount} reference entries covering DSM-5-TR criteria, ICD-10-CM codes, ERP / ACT / CBT protocols, and validated assessment instruments — specific to anxiety-spectrum, OCD, and related presentations.</p>
          <div style={dp.refList}>
            <p style={dp.refListLabel}>Source References</p>
            <p style={dp.refItem}><span style={dp.refAuthor}>American Psychiatric Association.</span> (2022). <span style={dp.refItalic}>Diagnostic and statistical manual of mental disorders</span> (5th ed., text rev.). DSM-5-TR diagnostic criteria reproduced in summary form for clinical reference.</p>
            <p style={dp.refItem}><span style={dp.refAuthor}>World Health Organization.</span> (2022). <span style={dp.refItalic}>ICD-10-CM clinical modification.</span> Centers for Medicare & Medicaid Services. Diagnostic codes used under standard clinical practice provisions.</p>
            <p style={dp.refItem}><span style={dp.refAuthor}>Goodman, W. K., et al.</span> (1989). The Yale-Brown Obsessive Compulsive Scale (Y-BOCS). <span style={dp.refItalic}>Archives of General Psychiatry, 46</span>(11), 1006–1011.</p>
            <p style={dp.refItem}><span style={dp.refAuthor}>Spitzer, R. L., et al.</span> (2006). A brief measure for assessing generalized anxiety disorder (GAD-7). <span style={dp.refItalic}>Archives of Internal Medicine, 166</span>(10), 1092–1097.</p>
            <p style={dp.refItem}><span style={dp.refAuthor}>Meyer, T. J., et al.</span> (1990). Development and validation of the Penn State Worry Questionnaire (PSWQ). <span style={dp.refItalic}>Behaviour Research and Therapy, 28</span>(6), 487–495.</p>
            <p style={dp.refItem}><span style={dp.refAuthor}>Frost, R. O., et al.</span> (1990). The dimensions of perfectionism (FMPS). <span style={dp.refItalic}>Cognitive Therapy and Research, 14</span>(5), 449–468.</p>
            <p style={dp.refItem}><span style={dp.refAuthor}>Abramowitz, J. S., & Jacoby, R. J.</span> (2015). Obsessive-compulsive disorder in adults. <span style={dp.refItalic}>Hogrefe Publishing.</span> ERP protocol framework adapted from inhibitory learning model.</p>
            <p style={dp.refItem}><span style={dp.refAuthor}>Hayes, S. C., Strosahl, K. D., & Wilson, K. G.</span> (2012). <span style={dp.refItalic}>Acceptance and commitment therapy</span> (2nd ed.). Guilford Press. ACT hexaflex and process descriptions adapted for clinical reference.</p>
            <p style={dp.refItem}><span style={dp.refAuthor}>Beck, A. T., & Clark, D. A.</span> (2010). <span style={dp.refItalic}>Cognitive therapy of anxiety disorders.</span> Guilford Press. CBT anxiety model and techniques adapted for clinical reference.</p>
            <p style={dp.refItem}><span style={dp.refAuthor}>Shafran, R., Cooper, Z., & Fairburn, C. G.</span> (2002). Clinical perfectionism: A cognitive-behavioural analysis. <span style={dp.refItalic}>Behaviour Research and Therapy, 40</span>(7), 773–791.</p>
            <p style={dp.refItem}><span style={dp.refAuthor}>Miller, W. R., & Rollnick, S.</span> (2013). <span style={dp.refItalic}>Motivational interviewing</span> (3rd ed.). Guilford Press. OARS and change talk framework adapted for clinical reference.</p>
            <p style={dp.refNote}>All DSM-5-TR criteria are summarised for clinical reference purposes. Full diagnostic criteria, differential guidance, and specifier details are available in the DSM-5-TR source text. ICD-10-CM codes reflect current CMS releases; verify coding with your billing provider for payer-specific requirements.</p>
          </div>
        </div>
      </div>

    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// DRAWER
// ─────────────────────────────────────────────────────────────────────────────
const NAV = [
  { id: "chat",      label: "Chat"      },
  { id: "icd",       label: "ICD-10"    },
  { id: "reference", label: "Reference" },
];

function Drawer({ open, activePanel, onPanel, onClose,
                  sessions, activeId, onLoad, onNew, onDelete,
                  source, setSource,
                  localFiles, setLocalFiles, addLocalFiles,
                  onOpenIcdInMain, onOpenRefInMain, brainCount, brainSource }) {
  const [mounted, setMounted] = useState(false);

  // Mount immediately on first open; stay mounted for smooth transitions
  useEffect(() => { if (open && !mounted) setMounted(true); }, [open]);
  if (!mounted) return null;

  return (
    <>
      {/* Scrim — fade in/out */}
      <div style={{
        position: "fixed", inset: 0, background: C.scrim, zIndex: 200,
        opacity: open ? 1 : 0, pointerEvents: open ? "auto" : "none",
        transition: "opacity 0.28s ease",
      }} onClick={onClose} />

      {/* Drawer panel — slide in/out */}
      <div style={{
        position: "fixed", top: 0, left: 0, bottom: 0,
        width: "82vw", maxWidth: 320,
        background: C.drawerBg,
        zIndex: 201,
        display: "flex", flexDirection: "column",
        // Smooth physics: ease-out on open, ease-in on close
        transform: open ? "translateX(0)" : "translateX(-100%)",
        transition: open
          ? "transform 0.32s cubic-bezier(0.22, 1, 0.36, 1)"
          : "transform 0.26s cubic-bezier(0.55, 0, 1, 0.45)",
        willChange: "transform",
        boxShadow: open ? "4px 0 32px rgba(0,0,0,0.18)" : "none",
        overflowY: "hidden",
      }}>

        {/* ── Drawer header */}
        <div style={dw.head}>
          <div style={dw.brand}>
            <img src={ICON} width={26} height={26} alt="GCC.ai"
              style={{ borderRadius: "22%", display: "block" }} />
            <span style={dw.wordmark}>GCC.ai</span>
          </div>
          <button style={dw.closeBtn} onClick={onClose} aria-label="Close menu">
            <svg width={14} height={14} viewBox="0 0 14 14" fill="none">
              <line x1="1" y1="1" x2="13" y2="13" stroke={C.muted} strokeWidth="1.8" strokeLinecap="round"/>
              <line x1="13" y1="1" x2="1" y2="13" stroke={C.muted} strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* ── Brain status strip */}
        <div style={dw.brainStrip}>
          <span style={dw.brainDot} />
          <span style={dw.brainText}>Integrated · {brainCount} reference entries</span>
        </div>

        {/* ── Nav tabs */}
        <div style={dw.tabs}>
          {NAV.map(item => (
            <button key={item.id}
              style={{ ...dw.tab, ...(activePanel === item.id ? dw.tabActive : {}) }}
              onClick={() => onPanel(item.id)}>
              {item.label}
              {item.id === "chat" && sessions.length > 0 &&
                <span style={dw.tabBadge}>{sessions.length}</span>}
            </button>
          ))}
        </div>

        {/* ── Panel content */}
        <div style={dw.content}>
          {activePanel === "chat"      && <ChatPanel sessions={sessions} activeId={activeId} onLoad={id => { onLoad(id); onClose(); }} onNew={() => { onNew(); onClose(); }} onDelete={onDelete} />}
          {activePanel === "icd"       && <IcdPanel onOpenInMain={r => { onOpenIcdInMain(r); }} />}
          {activePanel === "reference" && <ReferencePanel onOpenInMain={r => { onOpenRefInMain(r); }} />}
          {activePanel === "settings"  && <SettingsPanel source={source} setSource={setSource} localFiles={localFiles} setLocalFiles={setLocalFiles} addLocalFiles={addLocalFiles} brainCount={brainCount} brainSource={brainSource} />}
        </div>

        {/* ── Footer — settings link + identity */}
        <div style={dw.foot}>
          <button style={dw.settingsLink}
            onClick={() => onPanel(activePanel === "settings" ? "chat" : "settings")}>
            {activePanel === "settings" ? "← Back" : "Settings"}
          </button>
          <div style={dw.identity}>
            <span style={dw.identityPrimary}>Greenleaf Counseling & Consulting</span>
            <span style={dw.identitySub}>Jonathan Porter, MA, LPC-S, NCC</span>
          </div>
        </div>
      </div>
    </>
  );
}

// Drawer structural styles
const dw = {
  head:     { display:"flex", justifyContent:"space-between", alignItems:"center",
              padding:"max(env(safe-area-inset-top),52px) 18px 14px",
              borderBottom:`1px solid ${C.drawerLine}` },
  brand:    { display:"flex", alignItems:"center", gap:9 },
  wordmark: { fontFamily:"'DM Serif Display',serif", fontSize:19, color:C.drawerText, letterSpacing:"0.2px" },
  closeBtn: { background:"none", border:"none", cursor:"pointer", padding:4, display:"flex", alignItems:"center" },
  brainStrip: { display:"flex", alignItems:"center", gap:6, padding:"7px 18px",
                background:C.drawerPanel, borderBottom:`1px solid ${C.drawerLine}` },
  brainDot: { width:6, height:6, borderRadius:"50%", background:C.forest, flexShrink:0 },
  brainText:{ fontSize:11, color:C.forest, letterSpacing:"0.2px" },
  tabs:     { display:"flex", borderBottom:`1px solid ${C.drawerLine}` },
  tab:      { flex:1, padding:"11px 0", fontSize:13, color:C.drawerMuted,
              background:"none", border:"none", borderBottom:"2px solid transparent",
              cursor:"pointer", fontFamily:"'DM Sans',system-ui,sans-serif",
              transition:"color 0.15s, border-color 0.15s", position:"relative" },
  tabActive:{ color:C.forest, borderBottom:`2px solid ${C.forest}`, fontWeight:600 },
  tabBadge: { display:"inline-block", marginLeft:5, fontSize:10, background:C.forestDim,
              color:C.forest, borderRadius:999, padding:"1px 5px" },
  content:  { flex:1, overflowY:"auto", WebkitOverflowScrolling:"touch", overscrollBehavior:"contain" },
  foot:     { borderTop:`1px solid ${C.drawerLine}`,
              padding:"10px 18px max(env(safe-area-inset-bottom),12px)",
              display:"flex", justifyContent:"space-between", alignItems:"flex-end" },
  settingsLink: { fontSize:12, color:C.drawerMuted, background:"none", border:"none",
                  cursor:"pointer", padding:0, fontFamily:"inherit",
                  textDecoration:"underline", textDecorationColor:"transparent",
                  transition:"color 0.15s" },
  identity:      { textAlign:"right" },
  identityPrimary: { display:"block", fontSize:11, color:C.drawerSand, fontWeight:500 },
  identitySub:   { display:"block", fontSize:10.5, color:C.drawerMuted, marginTop:1 },
};

// Panel inner styles — light palette
const dp = {
  panel:       { padding:"14px 16px 24px" },
  emptyNote:   { fontSize:13, color:C.muted, lineHeight:1.6, margin:"6px 0 0" },
  introText:   { fontSize:13.5, color:C.sand, lineHeight:1.6, margin:"0 0 14px" },
  refIntroBox: { background:C.ground, border:`1px solid ${C.line}`, borderRadius:9,
                 padding:"12px 13px", marginBottom:14 },
  refIntroText:{ fontSize:13.5, color:C.ivory, lineHeight:1.6, margin:"0 0 8px",
                 fontFamily:"'DM Sans',system-ui,sans-serif" },
  refIntroSub: { fontSize:12, color:C.muted, lineHeight:1.6, margin:0,
                 fontFamily:"'DM Sans',system-ui,sans-serif" },
  primaryBtn:  { width:"100%", background:C.forest, color:"#F3EFE4", border:"none",
                 borderRadius:10, padding:"11px", fontSize:14, fontWeight:600,
                 cursor:"pointer", fontFamily:"'DM Sans',system-ui,sans-serif",
                 marginBottom:12 },
  outlineBtn:  { width:"100%", background:"none", color:C.forest,
                 border:`1px solid ${C.forest}`, borderRadius:10,
                 padding:"10px", fontSize:13.5, fontWeight:500,
                 cursor:"pointer", fontFamily:"'DM Sans',system-ui,sans-serif",
                 marginBottom:8 },
  // Sessions
  sessRow:     { display:"flex", alignItems:"center", padding:"10px 0",
                 borderBottom:`1px solid ${C.lineSoft}`, cursor:"pointer", transition:"0.15s" },
  sessActive:  { background:C.forestDim, borderRadius:8, padding:"10px 8px", margin:"0 -8px" },
  sessInfo:    { flex:1, overflow:"hidden" },
  sessLabel:   { display:"block", fontSize:13.5, color:C.ivory, overflow:"hidden",
                 textOverflow:"ellipsis", whiteSpace:"nowrap" },
  sessDate:    { display:"block", fontSize:11, color:C.muted, marginTop:2 },
  rowX:        { fontSize:17, color:C.muted, background:"none", border:"none",
                 cursor:"pointer", padding:"0 4px", flexShrink:0, lineHeight:1 },
  // ICD search
  searchBar:   { display:"flex", gap:8, marginBottom:14 },
  searchInput: { flex:1, background:C.ground, border:`1px solid ${C.line}`,
                 borderRadius:9, padding:"9px 12px", color:C.ivory, fontSize:16,
                 fontFamily:"'DM Sans',system-ui,sans-serif" },
  searchBtn:   { background:C.forest, color:"#F3EFE4", border:"none", borderRadius:9,
                 padding:"9px 14px", fontSize:13, fontWeight:600, cursor:"pointer",
                 fontFamily:"'DM Sans',system-ui,sans-serif", flexShrink:0 },
  codeIndex:   { display:"flex", flexDirection:"column" },
  codeRow:     { display:"flex", alignItems:"baseline", gap:12, padding:"8px 0",
                 borderBottom:`1px solid ${C.lineSoft}`, background:"none", border_:"none",
                 cursor:"pointer", textAlign:"left",
                 fontFamily:"'DM Sans',system-ui,sans-serif", width:"100%",
                 borderTop:"none", borderLeft:"none", borderRight:"none",
                 borderBottomWidth:1, borderBottomStyle:"solid", borderBottomColor:C.lineSoft },
  codeTag:     { fontSize:12.5, color:C.forest, fontWeight:600, flexShrink:0, minWidth:50 },
  codeName:    { fontSize:13, color:C.ivory },
  resultWrap:  { background:C.panel2, border:`1px solid ${C.line}`,
                 borderRadius:10, padding:"13px 13px 15px" },
  backLink:    { fontSize:12, color:C.muted, background:"none", border:"none",
                 cursor:"pointer", padding:"0 0 10px", fontFamily:"inherit", display:"block" },
  resultHeader:{ display:"flex", alignItems:"center", gap:10, marginBottom:5 },
  resultCode:  { fontFamily:"'DM Serif Display',serif", fontSize:26, color:C.forest, lineHeight:1 },
  resultDsm:   { fontSize:11, color:C.muted, background:C.panel,
                 border:`1px solid ${C.line}`, borderRadius:6, padding:"3px 8px" },
  resultName:  { fontFamily:"'DM Serif Display',serif", fontSize:18, color:C.ivory,
                 margin:"0 0 12px", lineHeight:1.25, fontWeight:400 },
  criteriaBlock:{ background:C.panel, borderRadius:8, padding:"9px 11px", marginBottom:8 },
  notesBlock:  { background:C.forestDim, borderRadius:8, padding:"9px 11px" },
  blockLabel:  { fontSize:10, letterSpacing:"1.8px", textTransform:"uppercase",
                 color:C.bark, margin:"0 0 5px", fontFamily:"'DM Sans',system-ui,sans-serif" },
  blockBody:   { fontSize:13.5, lineHeight:1.65, color:C.ivory, margin:0,
                 fontFamily:"'DM Sans',system-ui,sans-serif" },
  resultMeta:  { fontSize:12, color:C.muted, margin:"0 0 8px" },
  resultPreview:{ fontSize:13, color:C.sand, lineHeight:1.6, margin:"0 0 12px" },
  openMainBtn: { width:"100%", background:C.forest, color:"#F3EFE4", border:"none",
                 borderRadius:9, padding:"10px", fontSize:13.5, fontWeight:600,
                 cursor:"pointer", fontFamily:"'DM Sans',system-ui,sans-serif" },
  notFound:    { fontSize:13, color:C.muted, marginTop:8 },
  // Reference viewer
  modeList:    { display:"flex", flexDirection:"column", gap:1 },
  modeRow:     { display:"flex", alignItems:"center", padding:"12px 0",
                 borderBottom:`1px solid ${C.lineSoft}`, background:"none",
                 border_:"none", cursor:"pointer", textAlign:"left", width:"100%",
                 fontFamily:"'DM Sans',system-ui,sans-serif",
                 borderTop:"none", borderLeft:"none", borderRight:"none",
                 borderBottomWidth:1, borderBottomStyle:"solid", borderBottomColor:C.lineSoft },
  modeText:    { flex:1 },
  modeTitle:   { display:"block", fontSize:14.5, color:C.ivory, fontWeight:500 },
  modeSub:     { display:"block", fontSize:12, color:C.muted, marginTop:2 },
  modeChevron: { fontSize:18, color:C.muted },
  textarea:    { width:"100%", minHeight:140, background:C.ground,
                 border:`1px solid ${C.line}`, borderRadius:9,
                 padding:"10px 12px", color:C.ivory, fontSize:14,
                 fontFamily:"monospace", resize:"vertical", marginBottom:10,
                 boxSizing:"border-box" },
  viewerBar:   { display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 },
  mdBody:      { },
  // Settings
  settingGroup:{ marginBottom:22 },
  settingLabel:{ fontSize:10, letterSpacing:"1.8px", textTransform:"uppercase",
                 color:C.bark, margin:"0 0 9px", display:"block" },
  settingInput:{ width:"100%", background:C.ground, border:`1px solid ${C.line}`,
                 borderRadius:9, padding:"10px 12px", color:C.ivory, fontSize:16,
                 fontFamily:"'DM Sans',system-ui,sans-serif", boxSizing:"border-box" },
  settingHint: { fontSize:11.5, color:C.muted, marginTop:6 },
  sourceRow:   { display:"flex", alignItems:"center", padding:"10px 12px",
                 background:C.ground, border:`1px solid ${C.line}`,
                 borderRadius:9, marginBottom:6, cursor:"pointer",
                 width:"100%", textAlign:"left",
                 fontFamily:"'DM Sans',system-ui,sans-serif", transition:"0.15s" },
  sourceActive:{ background:C.forestDim, borderColor:C.forest },
  sourceText:  { flex:1 },
  sourceTitle: { display:"block", fontSize:13.5, color:C.ivory, fontWeight:500 },
  sourceDesc:  { display:"block", fontSize:12, color:C.muted, marginTop:2 },
  sourceTick:  { fontSize:13, color:C.forest, flexShrink:0 },
  fileRow:     { display:"flex", justifyContent:"space-between", alignItems:"center",
                 padding:"7px 0", borderBottom:`1px solid ${C.lineSoft}` },
  fileName:    { fontSize:12.5, color:C.sand, flex:1, overflow:"hidden",
                 textOverflow:"ellipsis", whiteSpace:"nowrap" },
  copyrightBox:{ background:C.ground, border:`1px solid ${C.line}`, borderRadius:9, padding:"12px 13px" },
  copyrightText:{ fontSize:12, color:C.muted, lineHeight:1.7, margin:0, fontFamily:"'DM Sans',system-ui,sans-serif" },
  betaBox:     { background:C.ground, border:`1px solid ${C.line}`, borderRadius:9, padding:"13px 13px 14px" },
  betaHeader:  { display:"flex", alignItems:"center", gap:9, marginBottom:6 },
  betaBadge:   { fontSize:9.5, fontWeight:700, letterSpacing:"2px", color:C.forest,
                 background:C.forestDim, border:`1px solid ${C.forest}`, borderRadius:5,
                 padding:"2px 7px", fontFamily:"'DM Sans',system-ui,sans-serif" },
  betaVersion: { fontFamily:"'DM Serif Display',serif", fontSize:17, color:C.ivory, lineHeight:1 },
  betaName:    { fontSize:12, color:C.sand, margin:"0 0 11px", fontFamily:"'DM Sans',system-ui,sans-serif" },
  betaMeta:    { borderTop:`1px solid ${C.lineSoft}`, borderBottom:`1px solid ${C.lineSoft}`,
                 padding:"8px 0", marginBottom:10 },
  betaRow:     { display:"flex", justifyContent:"space-between", alignItems:"baseline",
                 padding:"4px 0" },
  betaKey:     { fontSize:11, color:C.muted, letterSpacing:"0.3px", fontFamily:"'DM Sans',system-ui,sans-serif" },
  betaVal:     { fontSize:11.5, color:C.ivory, fontFamily:"'DM Sans',system-ui,sans-serif", fontWeight:500 },
  betaDesc:    { fontSize:11.5, color:C.muted, lineHeight:1.65, margin:0,
                 fontFamily:"'DM Sans',system-ui,sans-serif" },
  refList:     { marginTop:12, paddingTop:10, borderTop:`1px solid ${C.lineSoft}` },
  refListLabel:{ fontSize:10, letterSpacing:"1.8px", textTransform:"uppercase", color:C.bark, margin:"0 0 8px", display:"block", fontFamily:"'DM Sans',system-ui,sans-serif" },
  refItem:     { fontSize:11.5, color:C.muted, lineHeight:1.65, margin:"0 0 8px", fontFamily:"'DM Sans',system-ui,sans-serif" },
  refAuthor:   { fontWeight:600, color:C.sand },
  refItalic:   { fontStyle:"italic" },
  refNote:     { fontSize:11, color:C.muted, lineHeight:1.6, margin:"10px 0 0", paddingTop:8, borderTop:`1px solid ${C.lineSoft}`, fontFamily:"'DM Sans',system-ui,sans-serif" },
  brainInfo:   { background:C.ground, border:`1px solid ${C.line}`,
                 borderRadius:9, padding:"12px 13px" },
  brainTitle:  { fontSize:13.5, color:C.ivory, fontWeight:500, margin:"0 0 5px" },
  brainBody:   { fontSize:12, color:C.muted, lineHeight:1.6, margin:"0 0 3px" },
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN APP
// ─────────────────────────────────────────────────────────────────────────────
export default function App() {
  const [liveBrain, setLiveBrain]     = useState(CLINICAL_KB);
  const [brainSource, setBrainSource]   = useState("embedded");
  const [drawerOpen, setDrawerOpen]   = useState(false);

  // ── Swipe gesture for drawer ─────────────────────────────────────────────
  // Right-swipe from left edge opens; left-swipe on open drawer closes.
  const swipeRef = useRef({ startX: 0, startY: 0, active: false });

  function onTouchStart(e) {
    const t = e.touches[0];
    swipeRef.current = { startX: t.clientX, startY: t.clientY, active: true };
  }

  function onTouchEnd(e) {
    if (!swipeRef.current.active) return;
    const t = e.changedTouches[0];
    const dx = t.clientX - swipeRef.current.startX;
    const dy = Math.abs(t.clientY - swipeRef.current.startY);
    swipeRef.current.active = false;
    // Only register horizontal swipes (dx dominant over dy)
    if (dy > 60) return;
    if (!drawerOpen && dx > 55 && swipeRef.current.startX < 32) {
      // Right swipe from left edge → open
      setDrawerOpen(true);
    } else if (drawerOpen && dx < -55) {
      // Left swipe anywhere when open → close
      setDrawerOpen(false);
    }
  }
  const [activePanel, setActivePanel] = useState("chat");
  const [icdResult, setIcdResult]       = useState(null);
  const [refResult, setRefResult]       = useState(null);
  const [refPdfAttachment, setRefPdfAttachment]   = useState(null); // PDF queried from ref viewer
  const [refTextAttachment, setRefTextAttachment] = useState(null); // MD/text queried from ref viewer
  const [sessions, setSessions]       = useState(() => loadSessions());
  const [activeId, setActiveId]       = useState(null);
  const [messages, setMessages]       = useState([]);
  const [input, setInput]             = useState("");
  const [loading, setLoading]         = useState(false);
  const [error, setError]             = useState("");
  const lastSendRef                       = useRef(null);
  const [source, setSource]           = useState("off");
  const [folder, setFolder]           = useState("");
  const [localFiles, setLocalFiles]   = useState([]);
  const scrollRef = useRef(null);
  const useLocal = source === "local";

  useEffect(() => {
    fetchAndCacheBrain().then(remote => {
      if (remote) {
        setLiveBrain(mergeBrain(remote));
        setBrainSource("remote");
      } else if ("caches" in window) {
        caches.open(BRAIN_CACHE_KEY)
          .then(c => c.match(BRAIN_FILE_URL))
          .then(m => { if (m) setBrainSource("cached"); })
          .catch(() => {});
      }
    });
  }, []);
  useEffect(() => { saveSessions(sessions); }, [sessions]);
  useEffect(() => {
    scrollRef.current?.scrollTo({ top: scrollRef.current.scrollHeight, behavior: "smooth" });
  }, [messages, loading]);

  // Sessions
  function startNew() {
    const sess = newSession();
    setSessions(prev => [sess, ...prev]);
    setActiveId(sess.id); setMessages([]); setError(""); setInput("");
  }
  function loadSession(id) {
    const sess = sessions.find(s => s.id === id);
    if (!sess) return;
    setActiveId(id); setMessages(sess.messages); setError(""); setInput("");
  }
  function deleteSession(id) {
    setSessions(prev => prev.filter(s => s.id !== id));
    if (activeId === id) { setActiveId(null); setMessages([]); }
  }
  function autoLabel(id, msg) {
    setSessions(prev => prev.map(s => s.id === id
      ? { ...s, label: msg.slice(0, 48) + (msg.length > 48 ? "…" : "") } : s));
  }
  function persistMessages(msgs) {
    if (!activeId) return;
    setSessions(prev => prev.map(s => s.id === activeId ? { ...s, messages: msgs } : s));
  }

  // Files
  function readFileB64(file) {
    return new Promise((res, rej) => {
      const r = new FileReader();
      r.onload = () => res((r.result).split(",")[1]);
      r.onerror = () => rej(new Error("read failed"));
      r.readAsDataURL(file);
    });
  }
  async function addLocalFiles(fileList) {
    const incoming = Array.from(fileList || []).filter(f => f.type === "application/pdf");
    if (!incoming.length) return;
    const loaded = await Promise.all(incoming.map(async f => ({ name: f.name, dataB64: await readFileB64(f) })));
    setLocalFiles(prev => { const names = new Set(prev.map(p => p.name)); return [...prev, ...loaded.filter(l => !names.has(l.name))]; });
  }

  // ── SEND ────────────────────────────────────────────────────────────────
  async function send(text) {
    const q = (text ?? input).trim();
    if (!q || loading) return;
    setError("");
    let cid = activeId;
    if (!cid) { const sess = newSession(); setSessions(prev => [sess, ...prev]); cid = sess.id; setActiveId(cid); }
    const next = [...messages, { role: "user", content: q }];
    setMessages(next); setInput(""); setLoading(true);
    if (messages.length === 0) autoLabel(cid, q);

    const brainHits = searchBrainIn(liveBrain, q);
    const brainCtx  = brainHits.length
      ? `\n\nCLINICAL BRAIN:\n${brainHits.map(h => `--- ${h.title} ---\n${h.content}`).join("\n\n")}\n\nCite section titles explicitly. If not covered, note this and use general clinical knowledge.`
      : "";

    const localLine = useLocal && localFiles.length
      ? `\n\nLOCAL DOCUMENTS (${localFiles.length}): ${localFiles.map(f => f.name).join(", ")}. Ground answers in these; cite explicitly.` : "";

    // Reference viewer attachments (override if present — one document at a time)
    const refPdfLine   = refPdfAttachment   ? `\n\nREFERENCE DOCUMENT (PDF): ${refPdfAttachment.name}. The clinician has opened this document and is asking about it. Ground your answer in it; cite by document name.` : "";
    const refTextLine  = refTextAttachment  ? `\n\nREFERENCE DOCUMENT (TEXT): ${refTextAttachment.name}. Content follows — ground your answer in it; cite by document name.\n\n${refTextAttachment.text.slice(0, 8000)}` : "";

    const system = `You are GCC.ai, the Greenleaf Counseling and Consulting clinical reference assistant for Jonathan Porter, MA, LPC-S, NCC — specialising in anxiety, OCD, clinical perfectionism, and mental performance using ERP, CBT, and ACT.

ROLE: Clinical reference and decision support. All clinical decisions rest with the clinician.

OUTPUT FORMAT for differential/diagnostic questions:
1. Presenting picture (brief)
2. DSM-5-TR criteria considered
3. Differentials with distinguishing features
4. ICD-10-CM code(s) with specifiers
5. Rule-outs / when to assess further

RULES: Prioritise Clinical Brain content; cite section titles. Surface competing diagnoses. Flag judgment calls. Reference GAD-7, Y-BOCS, PSWQ, FMPS when relevant. Use web_search to confirm codes/specifiers. Never fabricate citations. If PHI appears, note and continue de-identified.${brainCtx}${localLine}${refPdfLine}${refTextLine}`;

    const apiMessages = next.map(m => ({ role: m.role, content: m.content }));

    // Attach local PDFs (Reference Source setting)
    if (useLocal && localFiles.length) {
      const docBlocks = localFiles.map(f => ({ type: "document", source: { type: "base64", media_type: "application/pdf", data: f.dataB64 } }));
      apiMessages[apiMessages.length - 1] = { role: "user", content: [...docBlocks, { type: "text", text: q }] };
    }
    // Attach PDF opened from Reference viewer (takes precedence, appended after local docs)
    if (refPdfAttachment?.dataB64) {
      const prev = apiMessages[apiMessages.length - 1];
      const prevContent = Array.isArray(prev.content) ? prev.content : [{ type: "text", text: prev.content }];
      const pdfBlock = { type: "document", source: { type: "base64", media_type: "application/pdf", data: refPdfAttachment.dataB64 } };
      apiMessages[apiMessages.length - 1] = { role: "user", content: [pdfBlock, ...prevContent.filter(b => b.type !== "text" || !b.text.startsWith(q)), { type: "text", text: q }] };
      setRefPdfAttachment(null); // consume after send
    }
    if (refTextAttachment) {
      setRefTextAttachment(null); // consumed via system prompt — clear after send
    }
    const body: any = { model: "claude-haiku-4-5-20251001", max_tokens: 3000, system, messages: apiMessages, tools: [{ type: "web_search_20250305", name: "web_search" }] };


    lastSendRef.current = () => send(q);
    try {
      const res  = await fetch("/api/proxy", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
      const data = await res.json();
      const rt   = (data.content || []).filter(b => b.type === "text").map(b => b.text).join("\n").trim();
      const cited = brainHits.length > 0 || (useLocal && /per \[|from \[|per [A-Z]/i.test(rt));
      const nm = [...next, { role: "assistant", content: rt || "No response generated.", sourced: cited, brainHits: brainHits.map(h => h.title) }];
      setMessages(nm); persistMessages(nm);
      lastSendRef.current = null;
    } catch {
      setError("Connection failed. Check your network connection and try again.");
    } finally { setLoading(false); }
  }

  const hasMessages = messages.length > 0;
  const sourceLabel = source === "local"
    ? (localFiles.length ? `Local · ${localFiles.length} file${localFiles.length > 1 ? "s" : ""}` : "Local · no files added")
    : "Integrated";

  return (
    <div style={s.root} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Serif+Display&family=DM+Sans:wght@400;500;600&display=swap');
        *{box-sizing:border-box}
        ::-webkit-scrollbar{width:4px}
        ::-webkit-scrollbar-thumb{background:${C.line};border-radius:4px}
        .gl-in:focus,.dr-in:focus{outline:none;border-color:${C.forest}!important;box-shadow:0 0 0 2px ${C.forestDim}}
        .gl-chip:hover{opacity:0.82}
        .gl-send:hover:not(:disabled){background:${C.forestDim}!important}
        .gl-send:disabled{opacity:0.35;cursor:default}
        .gl-copy:hover{background:${C.forestDim}!important;color:${C.forest}!important}
        .dr-row:hover{opacity:0.8}
        html,body{overscroll-behavior:none;margin:0;padding:0;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-text-size-adjust:100%}
        button,input,textarea{-webkit-tap-highlight-color:transparent;-webkit-appearance:none}
        input::placeholder,textarea::placeholder{color:#7C8478;opacity:1}
        img{image-rendering:-webkit-optimize-contrast}
        @keyframes pulse{0%,100%{opacity:.25}50%{opacity:1}}
      `}</style>

      {/* ── SLIDE-OVER DRAWER */}
      <Drawer open={drawerOpen} activePanel={activePanel} onPanel={setActivePanel}
        onClose={() => setDrawerOpen(false)}
        sessions={sessions} activeId={activeId}
        onLoad={loadSession} onNew={startNew} onDelete={deleteSession}
        source={source} setSource={setSource}
        localFiles={localFiles} setLocalFiles={setLocalFiles} addLocalFiles={addLocalFiles}
        onOpenIcdInMain={r => { setIcdResult(r); setDrawerOpen(false); }}
        onOpenRefInMain={r => { setRefResult(r); setDrawerOpen(false); }}
        brainCount={liveBrain.length} brainSource={brainSource} />

      {/* ── HEADER */}
      <header style={s.header}>
        {/* Hamburger — triggers drawer */}
        <button style={s.hamburger} onClick={() => setDrawerOpen(v => !v)} aria-label="Open navigation">
          <Hamburger />
        </button>
        <span style={s.wordmark}>GCC.ai</span>
        <div style={s.headerRight}>
          <span style={s.headerBeta}>{BUILD.version}</span>
          {hasMessages && (
            <button style={s.headerAction} onClick={startNew}>New</button>
          )}
        </div>
      </header>

      {/* ── STATUS BAR */}
      <div style={s.statusBar}>
        <span style={s.statusDot} />
        <span style={s.statusText}>Clinical Reference · {liveBrain.length} entries{brainSource==="remote"?" · updated":brainSource==="cached"?" · cached":""}</span>
        <span style={s.statusSep}>·</span>
        <span style={s.statusText}>{sourceLabel}</span>
      </div>

      {/* ── REFERENCE DOCUMENT — opens in main view when triggered from drawer */}
      {refResult && (
        <div style={s.icdMain}>
          <div style={s.icdMainBar}>
            <button style={s.icdMainBack} onClick={() => {
              // Release PDF object URL to free memory
              if (refResult.type === "pdf" && refResult.url) URL.revokeObjectURL(refResult.url);
              setRefResult(null);
            }}>← Close</button>
            <span style={s.icdMainLabel}>{refResult.filename}</span>
            {refResult.type === "text" && <CopyBtn text={refResult.text} />}
          </div>

          {/* PDF — rendered via native browser iframe */}
          {refResult.type === "pdf" && (
            <div style={{ flex:1, display:"flex", flexDirection:"column" }}>
              <iframe
                src={refResult.url}
                style={{ flex:1, border:"none", width:"100%", display:"block" }}
                title={refResult.filename}
              />
              <div style={s.refAskBar}>
                <span style={s.refAskNote}>PDF loaded · AI can reference this document</span>
                <button style={s.refAskBtn} onClick={() => {
                  // Attach PDF to next query via localFiles mechanism
                  if (refResult.dataB64) {
                    const pdfEntry = { name: refResult.filename, dataB64: refResult.dataB64 };
                    setRefPdfAttachment(pdfEntry);
                    setInput(`Summarise the key clinical content in ${refResult.filename}`);
                  }
                  if (refResult.url) URL.revokeObjectURL(refResult.url);
                  setRefResult(null);
                }}>Ask about this document</button>
              </div>
            </div>
          )}

          {/* Text / Markdown — rendered via Md component */}
          {refResult.type === "text" && (
            <div style={{ flex:1, display:"flex", flexDirection:"column" }}>
              <div style={{ ...s.icdMainBody, flex:1, overflowY:"auto" }}>
                <Md text={refResult.text} />
              </div>
              <div style={s.refAskBar}>
                <span style={s.refAskNote}>Document loaded · AI can reference this content</span>
                <button style={s.refAskBtn} onClick={() => {
                  setInput(`Based on this document — ${refResult.name} — what are the key clinical considerations?`);
                  setRefTextAttachment({ name: refResult.filename, text: refResult.text });
                  setRefResult(null);
                }}>Ask about this document</button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── ICD RESULT — opens in main view when triggered from drawer */}
      {icdResult && (
        <div style={s.icdMain}>
          <div style={s.icdMainBar}>
            <button style={s.icdMainBack} onClick={() => setIcdResult(null)}>← Close</button>
            <span style={s.icdMainLabel}>Diagnostic Code Reference</span>
          </div>
          <div style={s.icdMainBody}>
            <div style={s.icdMainCodeRow}>
              <span style={s.icdMainCode}>{icdResult.code}</span>
              <span style={s.icdMainDsm}>DSM-5-TR {icdResult.dsm}</span>
            </div>
            <h2 style={s.icdMainName}>{icdResult.name}</h2>
            <div style={s.icdMainSection}>
              <p style={s.icdMainSectionLabel}>Diagnostic Criteria</p>
              <p style={s.icdMainSectionBody}>{icdResult.criteria}</p>
            </div>
            {icdResult.notes && (
              <div style={s.icdMainNotes}>
                <p style={s.icdMainSectionLabel}>Clinical Notes</p>
                <p style={s.icdMainSectionBody}>{icdResult.notes}</p>
              </div>
            )}
            <button style={s.icdMainAsk}
              onClick={() => {
                setInput(`Tell me more about ${icdResult.code} — ${icdResult.name}`);
                setIcdResult(null);
              }}>
              Ask about this diagnosis
            </button>
          </div>
        </div>
      )}

      {/* ── CHAT AREA — hidden when ICD result or reference document is open */}
      {!icdResult && !refResult && (
      <main ref={scrollRef} style={s.scroll}>
        {!hasMessages && (
          <div style={s.empty}>
            <div style={s.heroMark}>
              <img src={ICON} width={58} height={58} alt="GCC.ai" style={{ borderRadius: "22%" }} />
            </div>
            <h1 style={s.heroTitle}>A licensed therapist<br />clinical reference</h1>
            <p style={s.heroSub}>Work through differential diagnosis, DSM-5-TR criteria, and diagnostic coding. Use the menu to access the diagnostic code library, clinical document viewer, and configuration.</p>
            <div style={s.chips}>
              {SUGGESTIONS.map(q => (
                <button key={q} className="gl-chip" style={s.chip} onClick={() => send(q)}>{q}</button>
              ))}
            </div>
          </div>
        )}

        {messages.map((m, i) => (
          <div key={i} style={m.role === "user" ? s.userRow : s.aiRow}>
            {m.role === "assistant" && (
              <img src={ICON} width={24} height={24} alt=""
                style={{ borderRadius: "22%", flexShrink: 0, marginTop: 2 }} />
            )}
            <div style={m.role === "user" ? s.userBubble : s.aiBubble}>
              {m.role === "user" ? <p style={s.p}>{m.content}</p> : <Fmt text={m.content} />}
              {m.role === "assistant" && (
                <div style={s.bubbleFooter}>
                  <div style={s.bubbleTags}>
                    {m.sourced && m.brainHits?.length > 0 && (
                      <span style={s.sourced} title={m.brainHits.join(", ")}>
                        <span style={s.dotG} />
                        Brain: {m.brainHits[0].split("—")[0].trim()}{m.brainHits.length > 1 ? ` +${m.brainHits.length - 1}` : ""}
                      </span>
                    )}
                  </div>
                  <CopyBtn text={m.content} />
                </div>
              )}
            </div>
          </div>
        ))}

        {loading && (
          <div style={s.aiRow}>
            <img src={ICON} width={24} height={24} alt=""
              style={{ borderRadius: "22%", flexShrink: 0, marginTop: 2 }} />
            <div style={s.aiBubble}>
              <span style={s.think}>
                {brainPreview(input || "…")}
                <span style={{ animation: "pulse 1.4s infinite" }}>…</span>
              </span>
            </div>
          </div>
        )}
        {error && (
          <div style={s.errWrap}>
            <p style={s.err}>{error}</p>
            {lastSendRef.current && (
              <button style={s.retryBtn} onClick={() => {
                const retry = lastSendRef.current;
                lastSendRef.current = null;
                setError("");
                setMessages(prev => prev.slice(0, -1));
                retry();
              }}>
                Retry
              </button>
            )}
          </div>
        )}
      </main>
      )}

      {/* ── FOOTER */}
      <footer style={s.footer}>
        <div style={s.inputWrap}>
          <input className="gl-in" style={s.input} value={input}
            placeholder="Describe a presentation or ask a clinical question…"
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => e.key === "Enter" && !e.shiftKey && send()} />
          <button className="gl-send" style={s.send}
            disabled={loading || !input.trim()} onClick={() => send()}>
            <img src={ICON} width={22} height={22} alt=""
              style={{ borderRadius: "22%" }} />
          </button>
        </div>
        <p style={s.disc}>{DISCLAIMER}</p>
      </footer>
    </div>
  );
}

// ─── MAIN STYLES ──────────────────────────────────────────────────────────────
const s = {
  root: { fontFamily:"'DM Sans',system-ui,sans-serif", background:C.ground, color:C.ivory,
          height:"100dvh", display:"flex", flexDirection:"column",
          paddingTop:"env(safe-area-inset-top)", paddingBottom:"env(safe-area-inset-bottom)",
          paddingLeft:"env(safe-area-inset-left)", paddingRight:"env(safe-area-inset-right)",
          WebkitTextSizeAdjust:"100%", touchAction:"manipulation",
          WebkitFontSmoothing:"antialiased", MozOsxFontSmoothing:"grayscale" },
  header:      { display:"flex", alignItems:"center", padding:"8px 16px", gap:10,
                 background:C.headerBg, minHeight:52 },
  hamburger:   { background:"none", border:"none", cursor:"pointer", padding:"6px 8px 6px 0",
                 display:"flex", alignItems:"center", flexShrink:0 },
  wordmark:    { fontFamily:"'DM Serif Display',serif", fontSize:21, color:"#F3EFE4",
                 letterSpacing:"0.2px", flex:1 },
  headerRight: { display:"flex", alignItems:"center", gap:8, marginLeft:"auto" },
  headerBeta:  { fontSize:10, fontWeight:700, letterSpacing:"1.8px", color:"#5C9468",
                 background:"rgba(92,148,104,0.18)", border:"1px solid rgba(92,148,104,0.45)",
                 borderRadius:6, padding:"3px 8px", flexShrink:0 },
  headerAction:{ fontSize:12, color:C.headerSand, background:"transparent",
                 border:`1px solid ${C.headerBorder}`, borderRadius:999,
                 padding:"6px 14px", cursor:"pointer", fontFamily:"inherit", flexShrink:0 },
  statusBar:   { display:"flex", alignItems:"center", gap:6, padding:"5px 16px",
                 background:C.panel2, borderBottom:`1px solid ${C.line}` },
  statusDot:   { width:6, height:6, borderRadius:"50%", background:C.forest, flexShrink:0 },
  statusText:  { fontSize:11, color:C.forest },
  statusSep:   { fontSize:11, color:C.muted, opacity:0.45 },
  scroll:      { flex:1, overflowY:"auto", padding:"14px 14px 8px", WebkitOverflowScrolling:"touch" },
  empty:       { maxWidth:"100%", margin:"3vh auto 0", textAlign:"center", padding:"0 4px" },
  heroMark:    { display:"inline-flex", padding:14, border:`1px solid ${C.line}`,
                 borderRadius:22, marginBottom:20, background:C.panel },
  heroTitle:   { fontFamily:"'DM Serif Display',serif", fontSize:27, lineHeight:1.15,
                 margin:"0 0 11px", color:C.ivory },
  heroSub:     { fontSize:14, lineHeight:1.6, color:C.muted, maxWidth:320, margin:"0 auto 22px" },
  chips:       { display:"grid", gridTemplateColumns:"1fr", gap:7 },
  chip:        { textAlign:"left", background:C.panel, color:C.chipText,
                 border:`1px solid ${C.line}`, borderRadius:11, padding:"11px 13px",
                 fontSize:14, cursor:"pointer", transition:"opacity 0.15s", fontFamily:"inherit" },
  userRow:     { display:"flex", justifyContent:"flex-end", margin:"12px 0" },
  aiRow:       { display:"flex", gap:10, margin:"12px 0" },
  userBubble:  { background:C.panelWarm, border:`1px solid ${C.line}`,
                 borderRadius:"14px 14px 4px 14px", padding:"10px 14px", maxWidth:"82%" },
  aiBubble:    { background:C.panel, border:`1px solid ${C.line}`,
                 borderRadius:"4px 14px 14px 14px", padding:"12px 14px", flex:1 },
  bubbleFooter:{ display:"flex", alignItems:"center", justifyContent:"space-between",
                 marginTop:8, paddingTop:7, borderTop:`1px solid ${C.lineSoft}`, gap:8 },
  bubbleTags:  { display:"flex", gap:6, flex:1 },
  sourced:     { fontSize:11, color:C.forest, display:"flex", alignItems:"center", gap:5 },
  dotG:        { width:6, height:6, borderRadius:"50%", background:C.forest, flexShrink:0, display:"inline-block" },
  copyBtn:     { fontSize:11, color:C.muted, background:"transparent",
                 border:`1px solid ${C.line}`, borderRadius:6,
                 padding:"3px 8px", cursor:"pointer", fontFamily:"inherit",
                 transition:"0.15s", flexShrink:0, marginLeft:"auto" },
  p:           { margin:"0 0 2px", fontSize:14.5, lineHeight:1.65 },
  h4:          { fontFamily:"'DM Serif Display',serif", fontSize:15.5,
                 margin:"13px 0 5px", color:C.forest, fontWeight:400 },
  bullet:      { display:"flex", gap:8, fontSize:14.5, lineHeight:1.6, margin:"3px 0" },
  dot:         { color:C.bark, flexShrink:0 },
  think:       { fontSize:13.5, color:C.sand, fontStyle:"italic" },
  err:         { color:"#B85C45", fontSize:13, textAlign:"center", margin:0 },
  errWrap:     { display:"flex", flexDirection:"column", alignItems:"center", gap:10, padding:"12px 0" },
  retryBtn:    { fontSize:13, color:C.forest, background:"transparent", border:`1px solid ${C.forest}`, borderRadius:8, padding:"7px 20px", cursor:"pointer", fontFamily:"inherit", fontWeight:500 },
  footer:      { borderTop:`1px solid ${C.footerBorder}`, padding:"11px 14px max(13px, env(safe-area-inset-bottom))",
                 background:C.footerBg },
  inputWrap:   { display:"flex", gap:8 },
  input:       { flex:1, background:C.panel, border:`1px solid ${C.line}`,
                 borderRadius:12, padding:"12px 14px", color:C.ivory,
                 fontSize:16, fontFamily:"inherit", transition:"0.2s" },
  send:        { width:46, background:C.panel2, border:`1px solid ${C.forest}`,
                 borderRadius:12, cursor:"pointer", display:"flex",
                 alignItems:"center", justifyContent:"center",
                 transition:"0.2s", flexShrink:0 },
  disc:        { maxWidth:860, margin:"6px auto 0", fontSize:11.5, color:C.sand,
                 lineHeight:1.4, textAlign:"center", padding:"0 4px" },
  // ICD full-view in main content area
  icdMain:     { flex:1, overflowY:"auto", background:C.panel,
                 display:"flex", flexDirection:"column" },
  icdMainBar:  { display:"flex", alignItems:"center", gap:12, padding:"10px 16px",
                 borderBottom:`1px solid ${C.line}`, background:C.panel2, flexShrink:0 },
  icdMainBack: { fontSize:13, color:C.forest, background:"none", border:"none",
                 cursor:"pointer", padding:0, fontFamily:"inherit", fontWeight:500 },
  icdMainLabel:{ fontSize:11, color:C.muted, letterSpacing:"1.5px",
                 textTransform:"uppercase" },
  icdMainBody: { padding:"20px 18px 40px", overflowY:"auto",
                 WebkitOverflowScrolling:"touch", flex:1, overscrollBehavior:"contain" },
  icdMainCodeRow:{ display:"flex", alignItems:"center", gap:12, marginBottom:8 },
  icdMainCode: { fontFamily:"'DM Serif Display',serif", fontSize:34, color:C.forest,
                 lineHeight:1 },
  icdMainDsm:  { fontSize:12, color:C.muted, background:C.panel2,
                 border:`1px solid ${C.line}`, borderRadius:6, padding:"4px 10px" },
  icdMainName: { fontFamily:"'DM Serif Display',serif", fontSize:22, color:C.ivory,
                 margin:"0 0 20px", lineHeight:1.2, fontWeight:400 },
  icdMainSection:{ background:C.ground, border:`1px solid ${C.line}`,
                   borderRadius:10, padding:"14px 15px", marginBottom:12 },
  icdMainNotes:{ background:C.forestDim, border:`1px solid ${C.line}`,
                 borderRadius:10, padding:"14px 15px", marginBottom:18 },
  icdMainSectionLabel:{ fontSize:10, letterSpacing:"2px", textTransform:"uppercase",
                        color:C.bark, margin:"0 0 8px", display:"block" },
  icdMainSectionBody:{ fontSize:14.5, lineHeight:1.7, color:C.ivory, margin:0 },
  icdMainAsk:  { width:"100%", background:C.forest, color:"#F3EFE4", border:"none",
                 borderRadius:11, padding:"13px", fontSize:14.5, fontWeight:600,
                 cursor:"pointer", fontFamily:"inherit", marginTop:4 },
  refAskBar:   { flexShrink:0, display:"flex", alignItems:"center", justifyContent:"space-between",
                 gap:10, padding:"10px 16px", borderTop:`1px solid ${C.line}`,
                 background:C.panel2 },
  refAskNote:  { fontSize:11.5, color:C.forest, flex:1 },
  refAskBtn:   { fontSize:13, color:"#F3EFE4", background:C.forest, border:"none",
                 borderRadius:9, padding:"8px 16px", cursor:"pointer",
                 fontFamily:"inherit", fontWeight:600, flexShrink:0 },
};
